webpackJsonp([1],{

/***/ "1znQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8+oJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Esw7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IKZO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JCHv":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/element-ui/lib/element-ui.common.js
var element_ui_common = __webpack_require__("zL8q");
var element_ui_common_default = /*#__PURE__*/__webpack_require__.n(element_ui_common);

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// EXTERNAL MODULE: ./node_modules/element-ui/lib/theme-chalk/index.css
var theme_chalk = __webpack_require__("tvR6");
var theme_chalk_default = /*#__PURE__*/__webpack_require__.n(theme_chalk);

// EXTERNAL MODULE: ./src/sass/style.scss
var style = __webpack_require__("gVaA");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Header.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Header = ({
  name: 'header',
  data: function data() {
    return {
      activeIndex: '0'
    };
  },

  methods: {
    handleSelect: function handleSelect(key, keyPath) {
      // console.log(key, keyPath);
    },
    signOut: function signOut() {
      this.$GoogleAuth.signOut().then(function () {
        return window.location.reload(false);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-310c7da6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-header',{staticClass:"appHeader"},[_c('el-menu',{staticClass:"el-menu-demo",attrs:{"default-active":_vm.activeIndex,"mode":"horizontal"},on:{"select":_vm.handleSelect}},[_c('el-menu-item',{staticClass:"appHeader__logo",attrs:{"index":"0"}},[_c('router-link',{attrs:{"to":"/"}},[_c('img',{staticClass:"appHeader__logo__img",attrs:{"src":__webpack_require__("JCHv")}}),_vm._v(" "),_c('span',{staticClass:"appHeader__logo__title"},[_vm._v("Gamification Back-Office")])])],1),_vm._v(" "),_c('el-submenu',{attrs:{"index":"2"}},[_c('template',{slot:"title"},[_vm._v("Marketing activities")]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"2-1"}},[_c('router-link',{staticClass:"el-menu-item__link",attrs:{"to":"/marketing/premium"}},[_vm._v("\n          Premium activation\n        ")])],1),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"2-2"}},[_c('router-link',{staticClass:"el-menu-item__link",attrs:{"to":"/marketing/tips"}},[_vm._v("\n          Tips of the day\n        ")])],1)],2),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"3"}},[_c('router-link',{attrs:{"to":"/admin"}},[_vm._v("\n        Admin\n      ")])],1),_vm._v(" "),_c('el-menu-item',{staticClass:"el-menu__logout",attrs:{"index":"4"},on:{"click":_vm.signOut}},[_vm._v("\n      Sign out\n    ")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_Header = (esExports);
// CONCATENATED MODULE: ./src/components/Header.vue
function injectStyle (ssrContext) {
  __webpack_require__("c5Db")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-310c7da6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Header,
  components_Header,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_Header = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var App = ({
  name: 'app',
  components: {
    Headr: src_components_Header
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c33c862","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('el-container',{staticClass:"is-vertical"},[_c('Headr'),_vm._v(" "),_c('el-main',[_c('router-view')],1)],1)],1)}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("1znQ")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/HelloWorld.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var HelloWorld = ({
  name: 'HelloWorld',
  data: function data() {
    return {
      value1: null,
      value2: null,
      show: false
    };
  },
  mounted: function mounted() {},

  methods: {
    handleLogin: function handleLogin() {
      axios_default()({ method: 'GET', url: 'http://127.0.0.1:10010/auth/google' }).then(function (result) {
        console.log('result:', result);
      }, function (error) {
        console.error(error);
      });

      // window.location = 'https://accounts.google.com/o/oauth2/v2/auth?scope=https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fdrive.metadata.readonly&include_granted_scopes=true&state=state_parameter_passthrough_value&redirect_uri=http%3A%2F%2Flocalhost%3A8080&response_type=token&client_id=290692198781-2kibalbenl4ulk9m1jvcdhvm7d69ja6h.apps.googleusercontent.com';
      /*
      window.gapi.load('auth2', () => {
        const auth2 = window.gapi.auth2.init({
          client_id: 'YOUR-CLIENT-ID-HERE.apps.googleusercontent.com',
          cookiepolicy: 'single_host_origin',
        });
        auth2.attachClickHandler(this.$refs.signinBtn, {}, (googleUser) => {
          this.$emit('done', googleUser);
        }, error => console.log(error));
      });
      */
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b4c4b838","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HelloWorld.vue
var HelloWorld_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"appear":""}},[_c('div',{staticClass:"hello"},[_c('img',{attrs:{"src":__webpack_require__("jvJD")}}),_vm._v(" "),_c('h1',[_vm._v("Welcome to your dashboard!")]),_vm._v(" "),_c('h2',[_vm._v("Start managing your marketing activities")]),_vm._v(" "),_c('div',{staticClass:"g-signin2",attrs:{"data-onsuccess":"onSignIn"}}),_vm._v(" "),_c('div',{staticClass:"tip"},[_c('p',[_c('i',{staticClass:"el-icon-info"}),_vm._v(" "),_c('a',{attrs:{"href":"https://drive.google.com/file/d/1D4ULgn2XKCiUJiiZMUY-VC2voiAxYoNg/view","target":"_blank"}},[_vm._v("Read the guidelines")])])]),_vm._v(" "),_c('router-link',{staticClass:"folder folder--premium",attrs:{"to":"/marketing/premium"}},[_vm._v("\n      Premium\n    ")]),_vm._v(" "),_c('router-link',{staticClass:"folder folder--tips",attrs:{"to":"/marketing/tips"}},[_vm._v("\n      Tips of the day\n    ")])],1)])}
var HelloWorld_staticRenderFns = []
var HelloWorld_esExports = { render: HelloWorld_render, staticRenderFns: HelloWorld_staticRenderFns }
/* harmony default export */ var components_HelloWorld = (HelloWorld_esExports);
// CONCATENATED MODULE: ./src/components/HelloWorld.vue
function HelloWorld_injectStyle (ssrContext) {
  __webpack_require__("Esw7")
  __webpack_require__("IKZO")
}
var HelloWorld_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var HelloWorld___vue_template_functional__ = false
/* styles */
var HelloWorld___vue_styles__ = HelloWorld_injectStyle
/* scopeId */
var HelloWorld___vue_scopeId__ = "data-v-b4c4b838"
/* moduleIdentifier (server only) */
var HelloWorld___vue_module_identifier__ = null
var HelloWorld_Component = HelloWorld_normalizeComponent(
  HelloWorld,
  components_HelloWorld,
  HelloWorld___vue_template_functional__,
  HelloWorld___vue_styles__,
  HelloWorld___vue_scopeId__,
  HelloWorld___vue_module_identifier__
)

/* harmony default export */ var src_components_HelloWorld = (HelloWorld_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/entries.js
var entries = __webpack_require__("W3Iv");
var entries_default = /*#__PURE__*/__webpack_require__.n(entries);

// CONCATENATED MODULE: ./src/utils/languages.js
var languages_languages = [{ value: 'SQ', label: 'Albanian [SQ]' }, { value: 'DE', label: 'Allemand [DE]' }, { value: 'GB', label: 'English (UK) [GB]' }, { value: 'EN', label: 'English (USA) [EN]' }, { value: 'AR', label: 'Arab [AR]' }, { value: 'HY', label: 'Armenian [HY]' }, { value: 'AZ', label: 'Azerbaijani [AZ]' }, { value: 'BZ', label: 'Brezhoneg (Breton) [BZ]' }, { value: 'BG', label: 'Bulgarian [BG]' }, { value: 'CA', label: 'Catalan [CA]' }, { value: 'ZH', label: 'Simplified Chinese [ZH]' }, { value: 'TW', label: 'Traditional Chinese [TW]' }, { value: 'KO', label: 'Korean [KO]' }, { value: 'HR', label: 'Croatian [HR]' }, { value: 'DA', label: 'Danish [DA]' }, { value: 'ES', label: 'Spanish [ES]' }, { value: 'AG', label: 'Spanish-Argentine [AG]' }, { value: 'MX', label: 'Spanish-Mexican [MX]' }, { value: 'ET', label: 'Estonian [ET]' }, { value: 'EU', label: 'Euskera (Basque) [EU]' }, { value: 'FI', label: 'Finnish [FI]' }, { value: 'FR', label: 'French [FR]' }, { value: 'QC', label: 'French CA [QC]' }, { value: 'GL', label: 'Gallego [GL]' }, { value: 'EL', label: 'Greek [EL]' }, { value: 'KA', label: 'Georgian [KA]' }, { value: 'NL', label: 'Dutch [NL]' }, { value: 'HU', label: 'Hungarian [HU]' }, { value: 'HE', label: 'Hebrews [HE]' }, { value: 'ID', label: 'Indonesian [ID]' }, { value: 'IT', label: 'Italian [IT]' }, { value: 'JA', label: 'Japanese [JA]' }, { value: 'LO', label: 'Lao [LO]' }, { value: 'LV', label: 'Latvian [LV]' }, { value: 'LT', label: 'Lithuanian [LT]' }, { value: 'MS', label: 'Malaysian [MS]' }, { value: 'NO', label: 'Norwegian [NO]' }, { value: 'NN', label: 'Nynorsk (Norwegian) [NN]' }, { value: 'FA', label: 'Persian [FA]' }, { value: 'PL', label: 'Polish [PL]' }, { value: 'PT', label: 'Portuguese [PT]' }, { value: 'BR', label: 'Portuguese-Brazilian [BR]' }, { value: 'RO', label: 'Romanian [RO]' }, { value: 'RU', label: 'Russian [RU]' }, { value: 'SR', label: 'Serbian [SR]' }, { value: 'SK', label: 'Slovak [SK]' }, { value: 'SI', label: 'Slovenian [SI]' }, { value: 'SV', label: 'Swedish [SV]' }, { value: 'CS', label: 'Czech [CS]' }, { value: 'TH', label: 'Thai [TH]' }, { value: 'TR', label: 'Turkish [TR]' }, { value: 'UK', label: 'Ukrainian [UK]' }, { value: 'VN', label: 'Vietnamese [VN]' }, { value: 'MK', label: 'македонски (Macedonian) [MK]' }, { value: 'UG', label: 'ئۇيغۇر (Uyghur) [UG]' }, { value: 'UR', label: 'اردو (Urdu) [UR]' }, { value: 'SH', label: 'سنڌي (Sinhala) [SH]' }, { value: 'BN', label: 'বাংলা (Bengali) [BN]' }];


// CONCATENATED MODULE: ./src/utils/countries.js
var zones = {
  AF: ['AO', 'BF', 'BI', 'BJ', 'BW', 'CD', 'CF', 'CG', 'CI', 'CM', 'CV', 'DJ', 'DZ', 'EG', 'EH', 'ER', 'ET', 'GA', 'GH', 'GM', 'GN', 'GQ', 'GW', 'KE', 'KM', 'LR', 'LS', 'LY', 'MA', 'MG', 'ML', 'MR', 'MU', 'MW', 'MZ', 'NA', 'NE', 'NG', 'RE', 'RW', 'SC', 'SD', 'SL', 'SN', 'SO', 'ST', 'SZ', 'TD', 'TG', 'TN', 'TZ', 'UG', 'YT', 'ZA', 'ZM', 'ZW'],
  AS: ['AE', 'AF', 'AM', 'AZ', 'BD', 'BH', 'BN', 'BT', 'CC', 'CN', 'CX', 'CY', 'GE', 'HK', 'ID', 'IL', 'IN', 'IO', 'IQ', 'IR', 'JO', 'JP', 'KG', 'KH', 'KP', 'KR', 'KW', 'KZ', 'LA', 'LB', 'LK', 'MM', 'MN', 'MO', 'MV', 'MY', 'NP', 'OM', 'PH', 'PK', 'PS', 'QA', 'SA', 'SG', 'SY', 'TH', 'TJ', 'TL', 'TM', 'TW', 'UZ', 'VN', 'YE'],
  EU: ['AD', 'AL', 'AT', 'AX', 'BA', 'BE', 'BG', 'BY', 'CH', 'CZ', 'DE', 'DK', 'EE', 'ES', 'FI', 'FO', 'FR', 'GB', 'GG', 'GI', 'GR', 'HR', 'HU', 'IE', 'IM', 'IS', 'IT', 'JE', 'LI', 'LT', 'LU', 'LV', 'MC', 'MD', 'ME', 'MK', 'MT', 'NL', 'NO', 'PL', 'PT', 'RO', 'RS', 'RU', 'SE', 'SI', 'SJ', 'SK', 'SM', 'TR', 'UA', 'VA', 'XK'],
  NA: ['AG', 'AI', 'AN', 'AW', 'BB', 'BL', 'BM', 'BS', 'BZ', 'CA', 'CR', 'CU', 'DM', 'DO', 'GD', 'GL', 'GP', 'GT', 'HN', 'HT', 'JM', 'KN', 'KY', 'LC', 'MF', 'MQ', 'MS', 'MX', 'NI', 'PA', 'PM', 'PR', 'SV', 'TC', 'TT', 'US', 'VC', 'VG', 'VI'],
  OC: ['AS', 'AU', 'CK', 'FJ', 'FM', 'GU', 'KI', 'MH', 'MP', 'NC', 'NF', 'NR', 'NU', 'NZ', 'PF', 'PG', 'PN', 'PW', 'SB', 'TF', 'TK', 'TO', 'TV', 'VU', 'WF', 'WS'],
  SA: ['AR', 'BO', 'BR', 'CL', 'CO', 'CW', 'EC', 'FK', 'GF', 'GY', 'PE', 'PY', 'SR', 'UY', 'VE']
};

var countriesListByRegion = [{
  label: 'Africa',
  options: [{ value: 'DZ', label: 'Algeria (DZ)' }, { value: 'AO', label: 'Angola (AO)' }, { value: 'BJ', label: 'Benin (BJ)' }, { value: 'BW', label: 'Botswana (BW)' }, { value: 'BF', label: 'Burkina Faso (BF)' }, { value: 'BI', label: 'Burundi (BI)' }, { value: 'CM', label: 'Cameroon (CM)' }, { value: 'CV', label: 'Cape Verde (CV)' }, { value: 'CF', label: 'Central African Republic (CF)' }, { value: 'TD', label: 'Chad (TD)' }, { value: 'KM', label: 'Comoros (KM)' }, { value: 'CD', label: 'Congo, Dem. Republic (CD)' }, { value: 'CG', label: 'Congo, Republic (CG)' }, { value: 'DJ', label: 'Djibouti (DJ)' }, { value: 'EG', label: 'Egypt (EG)' }, { value: 'GQ', label: 'Equatorial Guinea (GQ)' }, { value: 'ER', label: 'Eritrea (ER)' }, { value: 'ET', label: 'Ethiopia (ET)' }, { value: 'GA', label: 'Gabon (GA)' }, { value: 'GM', label: 'Gambia (GM)' }, { value: 'GH', label: 'Ghana (GH)' }, { value: 'GN', label: 'Guinea (GN)' }, { value: 'GW', label: 'Guinea-Bissau (GW)' }, { value: 'CI', label: 'Ivory Coast (CI)' }, { value: 'KE', label: 'Kenya (KE)' }, { value: 'LS', label: 'Lesotho (LS)' }, { value: 'LR', label: 'Liberia (LR)' }, { value: 'LY', label: 'Libya (LY)' }, { value: 'MG', label: 'Madagascar (MG)' }, { value: 'MW', label: 'Malawi (MW)' }, { value: 'ML', label: 'Mali (ML)' }, { value: 'MR', label: 'Mauritania (MR)' }, { value: 'MU', label: 'Mauritius (MU)' }, { value: 'YT', label: 'Mayotte (YT)' }, { value: 'MA', label: 'Morocco (MA)' }, { value: 'MZ', label: 'Mozambique (MZ)' }, { value: 'NA', label: 'Namibia (NA)' }, { value: 'NE', label: 'Niger (NE)' }, { value: 'NG', label: 'Nigeria (NG)' }, { value: 'RE', label: 'Reunion Island (RE)' }, { value: 'RW', label: 'Rwanda (RW)' }, { value: 'ST', label: 'Sao Tome and Príncipe (ST)' }, { value: 'SN', label: 'Senegal (SN)' }, { value: 'SC', label: 'Seychelles (SC)' }, { value: 'SL', label: 'Sierra Leone (SL)' }, { value: 'SO', label: 'Somalia (SO)' }, { value: 'ZA', label: 'South Africa (ZA)' }, { value: 'SS', label: 'South Sudan (SS)' }, { value: 'SD', label: 'Sudan (SD)' }, { value: 'SZ', label: 'Swaziland (SZ)' }, { value: 'TZ', label: 'Tanzania (TZ)' }, { value: 'TG', label: 'Togo (TG)' }, { value: 'TN', label: 'Tunisia (TN)' }, { value: 'UG', label: 'Uganda (UG)' }, { value: 'EH', label: 'Western Sahara (EH)' }, { value: 'ZM', label: 'Zambia (ZM)' }, { value: 'ZW', label: 'Zimbabwe (ZW)' }]
}, {
  label: 'Asia',
  options: [{ value: 'AF', label: 'Afghanistan (AF)' }, { value: 'AM', label: 'Armenia (AM)' }, { value: 'AZ', label: 'Azerbaijan (AZ)' }, { value: 'BH', label: 'Bahrain (BH)' }, { value: 'BD', label: 'Bangladesh (BD)' }, { value: 'BT', label: 'Bhutan (BT)' }, { value: 'IO', label: 'British Indian Ocean Territory (IO)' }, { value: 'BN', label: 'Brunei (BN)' }, { value: 'MM', label: 'Burma (Myanmar) (MM)' }, { value: 'KH', label: 'Cambodia (KH)' }, { value: 'CN', label: 'China (CN)' }, { value: 'CX', label: 'Christmas Island (CX)' }, { value: 'CC', label: 'Cocos (Keeling) Islands (CC)' }, { value: 'CY', label: 'Cyprus (CY)' }, { value: 'TL', label: 'East Timor (TL)' }, { value: 'GE', label: 'Georgia (GE)' }, { value: 'HK', label: 'Hong Kong (HK)' }, { value: 'IN', label: 'India (IN)' }, { value: 'ID', label: 'Indonesia (ID)' }, { value: 'IR', label: 'Iran (IR)' }, { value: 'IQ', label: 'Iraq (IQ)' }, { value: 'IL', label: 'Israel (IL)' }, { value: 'JP', label: 'Japan (JP)' }, { value: 'JO', label: 'Jordan (JO)' }, { value: 'KZ', label: 'Kazakhstan (KZ)' }, { value: 'KP', label: 'Korea, Dem. Republic of (KP)' }, { value: 'KW', label: 'Kuwait (KW)' }, { value: 'KG', label: 'Kyrgyzstan (KG)' }, { value: 'LA', label: 'Laos (LA)' }, { value: 'LB', label: 'Lebanon (LB)' }, { value: 'MO', label: 'Macau (MO)' }, { value: 'MY', label: 'Malaysia (MY)' }, { value: 'MV', label: 'Maldives (MV)' }, { value: 'MN', label: 'Mongolia (MN)' }, { value: 'NP', label: 'Nepal (NP)' }, { value: 'OM', label: 'Oman (OM)' }, { value: 'PK', label: 'Pakistan (PK)' }, { value: 'PS', label: 'Palestinian Territories (PS)' }, { value: 'PH', label: 'Philippines (PH)' }, { value: 'QA', label: 'Qatar (QA)' }, { value: 'SA', label: 'Saudi Arabia (SA)' }, { value: 'SG', label: 'Singapore (SG)' }, { value: 'KR', label: 'South Korea (KR)' }, { value: 'LK', label: 'Sri Lanka (LK)' }, { value: 'SY', label: 'Syria (SY)' }, { value: 'TW', label: 'Taiwan (TW)' }, { value: 'TJ', label: 'Tajikistan (TJ)' }, { value: 'TH', label: 'Thailand (TH)' }, { value: 'TM', label: 'Turkmenistan (TM)' }, { value: 'AE', label: 'United Arab Emirates (AE)' }, { value: 'UZ', label: 'Uzbekistan (UZ)' }, { value: 'VN', label: 'Vietnam (VN)' }, { value: 'YE', label: 'Yemen (YE)' }]
}, {
  label: 'Europe',
  options: [{ value: 'AX', label: 'Aland Islands (AX)' }, { value: 'AL', label: 'Albania (AL)' }, { value: 'AD', label: 'Andorra (AD)' }, { value: 'AT', label: 'Austria (AT)' }, { value: 'BY', label: 'Belarus (BY)' }, { value: 'BE', label: 'Belgium (BE)' }, { value: 'BA', label: 'Bosnia and Herzegovina (BA)' }, { value: 'BG', label: 'Bulgaria (BG)' }, { value: 'HR', label: 'Croatia (HR)' }, { value: 'CZ', label: 'Czech Republic (CZ)' }, { value: 'DK', label: 'Denmark (DK)' }, { value: 'EE', label: 'Estonia (EE)' }, { value: 'FO', label: 'Faroe Islands (FO)' }, { value: 'FI', label: 'Finland (FI)' }, { value: 'FR', label: 'France (FR)' }, { value: 'DE', label: 'Germany (DE)' }, { value: 'GI', label: 'Gibraltar (GI)' }, { value: 'GR', label: 'Greece (GR)' }, { value: 'GG', label: 'Guernsey (GG)' }, { value: 'HU', label: 'Hungary (HU)' }, { value: 'IS', label: 'Iceland (IS)' }, { value: 'IE', label: 'Ireland (IE)' }, { value: 'IT', label: 'Italy (IT)' }, { value: 'JE', label: 'Jersey (JE)' }, { value: 'XK', label: 'Kosovo (XK)' }, { value: 'LV', label: 'Latvia (LV)' }, { value: 'LI', label: 'Liechtenstein (LI)' }, { value: 'LT', label: 'Lithuania (LT)' }, { value: 'LU', label: 'Luxembourg (LU)' }, { value: 'MK', label: 'Macedonia (MK)' }, { value: 'MT', label: 'Malta (MT)' }, { value: 'IM', label: 'Man Island (IM)' }, { value: 'MD', label: 'Moldova (MD)' }, { value: 'MC', label: 'Monaco (MC)' }, { value: 'ME', label: 'Montenegro (ME)' }, { value: 'NL', label: 'Netherlands (NL)' }, { value: 'NO', label: 'Norway (NO)' }, { value: 'PL', label: 'Poland (PL)' }, { value: 'PT', label: 'Portugal (PT)' }, { value: 'RO', label: 'Romania (RO)' }, { value: 'RU', label: 'Russia (RU)' }, { value: 'SM', label: 'San Marino (SM)' }, { value: 'RS', label: 'Serbia (RS)' }, { value: 'SK', label: 'Slovakia (SK)' }, { value: 'SI', label: 'Slovenia (SI)' }, { value: 'ES', label: 'Spain (ES)' }, { value: 'SJ', label: 'Svalbard and Jan Mayen (SJ)' }, { value: 'SE', label: 'Sweden (SE)' }, { value: 'CH', label: 'Switzerland (CH)' }, { value: 'TR', label: 'Turkey (TR)' }, { value: 'UA', label: 'Ukraine (UA)' }, { value: 'GB', label: 'United Kingdom (GB)' }, { value: 'VA', label: 'Vatican City State (VA)' }]
}, {
  label: 'North America',
  options: [{ value: 'AI', label: 'Anguilla (AI)' }, { value: 'AG', label: 'Antigua and Barbuda (AG)' }, { value: 'AW', label: 'Aruba (AW)' }, { value: 'BS', label: 'Bahamas (BS)' }, { value: 'BB', label: 'Barbados (BB)' }, { value: 'BQ', label: 'Barbecue (BQ)' }, { value: 'BZ', label: 'Belize (BZ)' }, { value: 'BM', label: 'Bermuda (BM)' }, { value: 'CA', label: 'Canada (CA)' }, { value: 'KY', label: 'Cayman Islands (KY)' }, { value: 'CR', label: 'Costa Rica (CR)' }, { value: 'CU', label: 'Cuba (CU)' }, { value: 'DM', label: 'Dominica (DM)' }, { value: 'DO', label: 'Dominican Republic (DO)' }, { value: 'SV', label: 'El Salvador (SV)' }, { value: 'GL', label: 'Greenland (GL)' }, { value: 'GD', label: 'Grenada (GD)' }, { value: 'GP', label: 'Guadeloupe (GP)' }, { value: 'GT', label: 'Guatemala (GT)' }, { value: 'HT', label: 'Haiti (HT)' }, { value: 'HN', label: 'Honduras (HN)' }, { value: 'JM', label: 'Jamaica (JM)' }, { value: 'MQ', label: 'Martinique (MQ)' }, { value: 'MX', label: 'Mexico (MX)' }, { value: 'MS', label: 'Montserrat (MS)' }, { value: 'AN', label: 'Netherlands Antilles (AN)' }, { value: 'NI', label: 'Nicaragua (NI)' }, { value: 'PA', label: 'Panama (PA)' }, { value: 'PR', label: 'Puerto Rico (PR)' }, { value: 'BL', label: 'Saint Barthelemy (BL)' }, { value: 'KN', label: 'Saint Kitts and Nevis (KN)' }, { value: 'LC', label: 'Saint Lucia (LC)' }, { value: 'MF', label: 'Saint Martin (MF)' }, { value: 'PM', label: 'Saint Pierre and Miquelon (PM)' }, { value: 'VC', label: 'Saint Vincent and the Grenadines (VC)' }, { value: 'TT', label: 'Trinidad and Tobago (TT)' }, { value: 'TC', label: 'Turks and Caicos Islands (TC)' }, { value: 'US', label: 'United States (US)' }, { value: 'VG', label: 'Virgin Islands (British) (VG)' }, { value: 'VI', label: 'Virgin Islands (U.S.) (VI)' }]
}, {
  label: 'Oceania',
  options: [{ value: 'AS', label: 'American Samoa (AS)' }, { value: 'AQ', label: 'Antartica (AQ)' }, { value: 'AU', label: 'Australia (AU)' }, { value: 'BV', label: 'Bouvet Island (BV)' }, { value: 'CK', label: 'Cook Islands (CK)' }, { value: 'FJ', label: 'Fiji (FJ)' }, { value: 'PF', label: 'French Polynesia (PF)' }, { value: 'TF', label: 'French Southern Territories (TF)' }, { value: 'GU', label: 'Guam (GU)' }, { value: 'KI', label: 'Kiribati (KI)' }, { value: 'MH', label: 'Marshall Islands (MH)' }, { value: 'FM', label: 'Micronesia (FM)' }, { value: 'NR', label: 'Nauru (NR)' }, { value: 'NC', label: 'New Caledonia (NC)' }, { value: 'NZ', label: 'New Zealand (NZ)' }, { value: 'NU', label: 'Niue (NU)' }, { value: 'NF', label: 'Norfolk Island (NF)' }, { value: 'MP', label: 'Northern Mariana Islands (MP)' }, { value: 'PW', label: 'Palau (PW)' }, { value: 'PG', label: 'Papua New Guinea (PG)' }, { value: 'PN', label: 'Pitcairn (PN)' }, { value: 'WS', label: 'Samoa (WS)' }, { value: 'SB', label: 'Solomon Islands (SB)' }, { value: 'TK', label: 'Tokelau (TK)' }, { value: 'TO', label: 'Tonga (TO)' }, { value: 'TV', label: 'Tuvalu (TV)' }, { value: 'VU', label: 'Vanuatu (VU)' }, { value: 'WF', label: 'Wallis and Futuna (WF)' }]
}, {
  label: 'South America',
  options: [{ value: 'AR', label: 'Argentina (AR)' }, { value: 'BO', label: 'Bolivia (BO)' }, { value: 'BR', label: 'Brazil (BR)' }, { value: 'CL', label: 'Chile (CL)' }, { value: 'CO', label: 'Colombia (CO)' }, { value: 'CW', label: 'Curacao (CW)' }, { value: 'EC', label: 'Ecuador (EC)' }, { value: 'FK', label: 'Falkland Islands (FK)' }, { value: 'GF', label: 'French Guiana (GF)' }, { value: 'GY', label: 'Guyana (GY)' }, { value: 'PY', label: 'Paraguay (PY)' }, { value: 'PE', label: 'Peru (PE)' }, { value: 'SR', label: 'Suriname (SR)' }, { value: 'UY', label: 'Uruguay (UY)' }, { value: 'VE', label: 'Venezuela (VE)' }]
}];


// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Premium.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var Premium = ({
  name: 'MktActList',
  data: function data() {
    return {
      env: Object({"NODE_ENV":"production","DEBUG_MODE":false}), // Environement variables
      deletion: {
        activities: [],
        loading: false,
        active: false
      },
      search: {
        hiddenActivities: [],
        query: ''
      },
      langOptions: languages_languages,
      zones: zones,
      visibilityOptions: countriesListByRegion,
      premiumActDialogVisible: false,
      premiumActRules: {
        name: [{ required: true, message: 'Please input Activity name', trigger: 'blur' }],
        techName: [{ required: true, message: 'Please input Activity Tech name', trigger: 'blur' }],
        content: [{
          required: true, message: 'Please input a content or remove this language', trigger: 'blur'
        }, {
          max: 80, message: 'length should be less than 80', trigger: 'blur'
        }]
      },
      newPremiumAct: {
        status: 'Off',
        name: '',
        techName: '',
        psVersionFrom: '',
        psVersionTo: '',
        languages: ['EN'],
        contents: { EN: '' },
        visibility: []
      },
      saving: false,
      premiumActs: [],
      editing: false,
      psVersions: [{ value: '1.0.0.0' }, { value: '1.1.0.0' }, { value: '1.2.0.0' }, { value: '1.2.5.0' }, { value: '1.3.0.0' }, { value: '1.3.0.1' }, { value: '1.4.0.1' }, { value: '1.4.0.10' }, { value: '1.4.7.0' }, { value: '1.5.0.0' }, { value: '1.5.0.17' }, { value: '1.5.3.1' }, { value: '1.5.4.1' }, { value: '1.5.5.0' }, { value: '1.5.6.0' }, { value: '1.5.6.1' }, { value: '1.5.6.3' }, { value: '1.6.0.0' }, { value: '1.6.0.14' }, { value: '1.6.0.4' }, { value: '1.6.0.5' }, { value: '1.6.0.6' }, { value: '1.6.1.0' }, { value: '1.6.1.1' }, { value: '1.6.1.4' }, { value: '1.6.1.5' }, { value: '1.6.1.12' }, { value: '1.6.1.15' }, { value: '1.6.1.17' }, { value: '1.6.1.24' }, { value: '1.7.0.2' }, { value: '1.7.0.3' }, { value: '1.7.0.4' }, { value: '1.7.0.5' }, { value: '1.7.0.6' }, { value: '1.7.1.0' }, { value: '1.7.1.1' }, { value: '1.7.1.2' }, { value: '1.7.2.0' }, { value: '1.7.2.1' }, { value: '1.7.2.2' }, { value: '1.7.2.3' }, { value: '1.7.2.4' }, { value: '1.7.2.5' }, { value: '1.7.3.0' }, { value: '1.7.3.1' }, { value: '1.7.3.2' }, { value: '1.7.3.3' }, { value: '1.7.3.4' }, { value: '1.7.4.0' }, { value: '1.7.4.1' }, { value: '1.7.4.2' }, { value: '1.7.4.3' }, { value: '1.7.4.4' }, { value: '1.7.5.0' }, { value: '1.7.5.1' }, { value: '1.7.5.2' }, { value: '1.7.6.0' }, { value: '1.7.6.1' }, { value: '1.7.6.2' }, { value: '1.7.6.3' }, { value: '1.7.6.4' }, { value: '1.7.6.5' }, { value: '1.7.6.6' }, { value: '1.7.6.7' }, { value: '1.7.6.8' }, { value: '1.7.6.9' }, { value: '1.7.7.0' }],
      filter: {
        languages: [],
        countries: [],
        hiddenActivities: [],
        status: ['Off', 'Stand by', 'On']
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    // Get the premium activations list
    axios_default()({
      method: 'GET',
      url: this.apiUrl + '/premium-activations',
      headers: {
        Authorization: this.$idToken
      }
    }).then(function (result) {
      console.log('result:', result);
      _this.premiumActs = result.data;
    }, function (error) {
      console.error(error);
    });
  },

  methods: {
    /**
     * When the user type a seach, filter the activities by matching name or
     * tech id
     * @param {Event} e
     */
    seachActivity: function seachActivity(e) {
      var query = e.target.value.toLowerCase();
      var matchs = [];
      for (var i = 0; i < this.premiumActs.length; i++) {
        var name = this.premiumActs[i].name.toLowerCase();
        var techName = this.premiumActs[i].techName.toLowerCase();
        if (name.indexOf(query) === -1 && techName.indexOf(query) === -1) {
          matchs.push(i);
        }
      }

      this.search.hiddenActivities = matchs;
    },

    /**
     * On click on a checkbox for the deletion of an activity, add / remove
     * this activity from this.deletion.activities
     * @param {Number} index - The index of the selected activity from this.tips
     * @param {Boolean} state - Whether or not the checkbox is checked
     */
    onChangeDeleteCheckbox: function onChangeDeleteCheckbox(index, state) {
      if (state === true) {
        this.deletion.activities.push(index);
      } else {
        var pos = this.deletion.activities.indexOf(index);
        this.deletion.activities.splice(pos, 1);
      }
    },

    /**
     * Delete all the activities in the `this.deletion.activities` array
     */
    deleteActivities: function deleteActivities() {
      var _this2 = this;

      console.log('On deleteActivities');
      // Set the loading state to the submit button
      this.deletion.loading = true;

      // Get the Google Storage keys of the activities to remove
      var activityKeys = [];
      for (var i = 0; i < this.deletion.activities.length; i++) {
        activityKeys.push(this.premiumActs[this.deletion.activities[i]].key);
      }

      console.log('activityKeys:', activityKeys);

      var data = {
        keys: activityKeys
      };

      console.log('data:', data);

      axios_default()({
        method: 'DELETE',
        url: this.apiUrl + '/premium-activations',
        data: data,
        headers: {
          Authorization: this.$idToken,
          'content-type': 'application/json'
        }
      }).then(function (result) {
        console.log('result:', result);

        // Notify the user that the update was successfull
        _this2.$notify.success({
          title: 'Deletion successfull',
          message: 'The selected activities has been deleted'
        });

        // Hide the deletion UI
        _this2.deletion = {
          activities: [],
          loading: false,
          active: false
        };

        // Update the tip list
        axios_default()({
          method: 'GET',
          url: _this2.apiUrl + '/premium-activations',
          headers: {
            Authorization: _this2.$idToken
          }
        }).then(function (activities) {
          _this2.premiumActs = activities.data;
        }, function (error) {
          console.error(error);
        });
      }).catch(function (error) {
        console.error(error);
        // Notify the user that an error occurred
        _this2.$notify.error({
          title: 'Error',
          message: 'An error has occurred, please contact the administrator'
        });

        _this2.deletion = {
          activities: [],
          loading: false,
          active: false
        };
      });
    },

    /**
     * Handle the changes on the file input for the premium activation logo
     * @param {Object} file - The submited file
     * @param {Array} fileList - The list of files for this upload component
     */
    onChangeLogo: function onChangeLogo(file, fileList) {
      var _this3 = this;

      var typeError = { title: 'Error', message: 'Only png files are allowed' };
      var dimError = { title: 'Error', message: 'The logo dimension must have a height of 44px (width of 170px recommended)' };
      var sizeError = { title: 'Error', message: 'The file size can\'t exceed 1 Mo' };

      // Check the type of the file
      if (file.raw.type !== 'image/png') {
        // Notify the user that an error occurred
        this.$notify.error(typeError);
        // Remove the file preview
        if (this.editing !== false) {
          this.$refs['logoUpload' + this.editing][0].clearFiles();
        } else {
          this.$refs.logoUpload.clearFiles();
        }
      }

      // Check dimensions of the uploaded image
      var reader = new FileReader();
      reader.onload = function (e) {
        var image = new Image();
        image.src = e.target.result;

        image.onload = function () {
          if (image.height !== 44) {
            // Notify the user that an error occurred
            _this3.$notify.error(dimError);
            // Remove the file preview
            if (_this3.editing !== false) {
              // If editing an existing marketing activity
              _this3.$refs['logoUpload' + _this3.editing][0].clearFiles();
            } else {
              // If editing a new marketing activity
              _this3.$refs.logoUpload.clearFiles();
            }
          }
        };
      };
      reader.readAsDataURL(file.raw);
    },

    /**
     * Triggers when the selected languages changes
     * @param {String} languages - current selected value
     */
    onChangeLanguages: function onChangeLanguages(languages) {
      // Check if a language has been removed and if yes, remove it from the
      // marketing activity contents

      // If we are editing an existing marketing activity
      if (this.editing !== false) {
        var contents = entries_default()(this.premiumActs[this.editing].contents);
        for (var i = 0; i < contents.length; i++) {
          var language = contents[i][0];
          if (languages.indexOf(language) === -1) {
            delete this.premiumActs[this.editing].contents[language];
          }
        }
      } else {
        // If editing a new marketing activity
        var _contents = entries_default()(this.newPremiumAct.contents);
        for (var _i = 0; _i < _contents.length; _i++) {
          var _language = _contents[_i][0];
          if (languages.indexOf(_language) === -1) {
            delete this.newPremiumAct.contents[_language];
          }
        }
      }

      for (var _i2 = 0; _i2 < languages.length; _i2++) {
        if (this.editing !== false && !this.premiumActs[this.editing].contents[languages[_i2]]) {
          // If editing an existing marketing activity
          // and no content for this language, create an empty field
          this.premiumActs[this.editing].contents[languages[_i2]] = '';
        } else if (!this.newPremiumAct.contents[languages[_i2]]) {
          // If editing a new marketing activity
          // and no content for this language, create an empty field
          this.newPremiumAct.contents[languages[_i2]] = '';
        }
      }
    },

    /**
     * Count the number of chars of the given description and prevent the user
     * to add more than the limit
     * @param {Event} e
     */
    countdownContent: function countdownContent(e) {
      var limit = 80;
      if (e.target.value.length >= limit) {
        e.preventDefault();
      }
    },
    querySearch: function querySearch(queryString, cb) {
      var psVersions = this.psVersions;
      var results = queryString ? psVersions.filter(this.createFilter(queryString)) : psVersions;
      // call callback function to return suggestions
      cb(results);
    },

    /**
     * @param {String} queryString
     */
    createFilter: function createFilter(queryString) {
      /* eslint-disable arrow-body-style */
      return function (psVersions) {
        return psVersions.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
      };
    },
    handleSelect: function handleSelect(item) {
      console.log(item);
    },

    /**
     * Reset the form
     */
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
      this.newPremiumAct = {
        isLive: false,
        name: '',
        techName: '',
        psVersionFrom: '',
        psVersionTo: '',
        languages: ['EN'],
        contents: { EN: '' },
        visibility: []
      };
      // Clear the uploaded file list
      this.$refs.logoUpload.clearFiles();
    },

    /**
     * addPremiumActivation
     */
    addPremiumActivation: function addPremiumActivation() {
      var _this4 = this;

      // Set the loading state on the submit btn
      this.saving = true;

      var data = new FormData();
      data.append('activity', stringify_default()(this.newPremiumAct));

      // If there is a logo to upload
      if (this.$refs.logoUpload.uploadFiles[0]) {
        // Get the file for the logo
        data.append('file', this.$refs.logoUpload.uploadFiles[0].raw);
      }

      // Insert an activity
      axios_default()({
        method: 'POST',
        url: this.apiUrl + '/premium-activations',
        data: data,
        headers: {
          Authorization: this.$idToken,
          'content-type': 'multipart/form-data'
        }
      }).then(function (result) {
        // Unset the loading state on the submit btn
        _this4.saving = false;

        // Clear the form
        _this4.resetForm('newPremiumActForm');

        // Close the modal
        _this4.premiumActDialogVisible = false;

        // Notify the user that the creation was successfull
        _this4.$notify.success({
          title: 'Successfull insert',
          message: 'The new Premium Activation has been added'
        });

        // Update the premium activation list
        axios_default()({
          method: 'GET',
          url: _this4.apiUrl + '/premium-activations',
          headers: {
            Authorization: _this4.$idToken
          }
        }).then(function (activities) {
          _this4.premiumActs = activities.data;
        }, function (error) {
          console.error(error);
        });
      }).catch(function (error) {
        console.error('Error:', error);
        // Unset the loading state on the submit btn
        _this4.saving = false;

        var activity = JSON.parse(data.get('activity'));
        switch (error.response.status) {
          case 401:
            // 401 Unauthorized
            _this4.$notify.error({
              title: 'Error',
              message: 'You are not authorized to add a new activity'
            });
            break;
          case 403:
            // 403 Forbidden
            _this4.$notify.error({
              title: 'Error',
              message: 'Non-existent bucket or you don\'t have the permission to\n              use it. Please contact your administrator'
            });
            break;
          case 409:
            // 409 Conflict
            _this4.$notify.error({
              title: 'Error',
              message: 'An activity with the tech name "' + activity.techName + '"\n              already exist'
            });
            break;
          case 400:
            // Missing or wrong parameter
            if (error.message) {
              _this4.$notify.error({
                title: 'Error',
                message: 'Missing of wrong information submited'
              });
            }
            break;
          default:
            _this4.$notify.error({
              title: 'Error',
              message: 'Unknow error. Please contact your administrator'
            });
            break;
        }
      });
    },

    /**
     * At the submit of the form
     */
    updatePremiumActivation: function updatePremiumActivation() {
      var _this5 = this;

      // Set the loading state on the submit btn
      this.saving = this.editing;

      if (this.editing !== false && this.premiumActs[this.editing]) {
        // Format the data to be send
        var data = new FormData();
        data.append('activity', stringify_default()(this.premiumActs[this.editing]));

        // If there is a logo to upload
        if (this.$refs['logoUpload' + this.editing][0].uploadFiles[0]) {
          // Get the file for the logo
          data.append('file', this.$refs['logoUpload' + this.editing][0].uploadFiles[0].raw);
        }

        // Update an activity
        axios_default()({
          method: 'PUT',
          url: this.apiUrl + '/premium-activations',
          data: data,
          headers: {
            Authorization: this.$idToken,
            'content-type': 'multipart/form-data'
          }
        }).then(function (result) {
          var activity = result.data;
          // Update the activity with the new data
          activity.logoUrl = activity.logoUrl + '?' + +new Date();
          _this5.premiumActs[_this5.editing] = activity;
          _this5.premiumActs[_this5.editing].key = ['Premium', activity.name];

          // Notify the user that the update was successfull
          _this5.$notify.success({
            title: 'Update successfull',
            message: activity.name + ' has been updated'
          });

          // Remove the file preview
          _this5.$refs['logoUpload' + _this5.editing][0].clearFiles();

          // Unset the loading state on the submit btn
          _this5.saving = false;

          // Close the activity edition panel
          _this5.editing = false;
        }, function (error) {
          console.error(error);
        });
      }
    },

    /**
     * Determine if an array contains one or more items from another array.
     * @param {array} haystack the array to search.
     * @param {array} arr the array providing items to check for in the haystack.
     * @return {boolean} true|false if haystack contains at least one item from arr.
     */
    findOne: function findOne(haystack, arr) {
      return arr.some(function (v) {
        // eslint-disable-line
        return haystack.indexOf(v) >= 0;
      });
    },

    /**
     * Apply the user filters
     */
    onApplyFilters: function onApplyFilters() {
      var matchs = [];
      for (var i = 0; i < this.premiumActs.length; i++) {
        var languages = this.premiumActs[i].languages;
        var visibility = this.premiumActs[i].visibility;
        var status = this.premiumActs[i].status;

        // If there is a language filter
        if (this.filter.languages.length && !this.findOne(languages, this.filter.languages)) {
          matchs.push(i);
        }

        // If there is a country filter
        if (this.filter.countries.length && this.filter.countries[0] !== '' && !this.findOne(visibility, this.filter.countries)) {
          matchs.push(i);
        }

        // If the status is not in the status filter
        if (!this.filter.status.includes(status)) {
          matchs.push(i);
        }
      }

      this.filter.hiddenActivities = matchs;
    },

    /**
     * Clear the filter form
     */
    onClearFilters: function onClearFilters() {
      this.filter = {
        languages: [],
        countries: [],
        hiddenActivities: [],
        status: ['Off', 'Stand by', 'On']
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-143ffc40","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Premium.vue
var Premium_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"appear":""}},[_c('div',[_c('el-dialog',{attrs:{"title":"Add a new Premium Activation","visible":_vm.premiumActDialogVisible,"width":"50%"},on:{"update:visible":function($event){_vm.premiumActDialogVisible=$event}}},[_c('el-form',{ref:"newPremiumActForm",staticClass:"mktAct__form",attrs:{"model":_vm.newPremiumAct,"rules":_vm.premiumActRules,"label-width":"120px"}},[_c('el-form-item',{attrs:{"label":"Status"}},[_c('el-radio-group',{model:{value:(_vm.newPremiumAct.status),callback:function ($$v) {_vm.$set(_vm.newPremiumAct, "status", $$v)},expression:"newPremiumAct.status"}},[_c('el-radio-button',{attrs:{"label":"Off"}}),_vm._v(" "),_c('el-radio-button',{attrs:{"label":"Stand by"}}),_vm._v(" "),_c('el-radio-button',{attrs:{"label":"On"}})],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Banner name","prop":"name"}},[_c('el-input',{model:{value:(_vm.newPremiumAct.name),callback:function ($$v) {_vm.$set(_vm.newPremiumAct, "name", $$v)},expression:"newPremiumAct.name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Tech name","prop":"techName"}},[_c('el-input',{model:{value:(_vm.newPremiumAct.techName),callback:function ($$v) {_vm.$set(_vm.newPremiumAct, "techName", $$v)},expression:"newPremiumAct.techName"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"PS versions"}},[_c('el-autocomplete',{staticClass:"inline-input",attrs:{"fetch-suggestions":_vm.querySearch,"placeholder":"Please Input"},on:{"select":_vm.handleSelect},model:{value:(_vm.newPremiumAct.psVersionFrom),callback:function ($$v) {_vm.$set(_vm.newPremiumAct, "psVersionFrom", $$v)},expression:"newPremiumAct.psVersionFrom"}}),_vm._v("\n          to\n          "),_c('el-autocomplete',{staticClass:"inline-input",attrs:{"fetch-suggestions":_vm.querySearch,"placeholder":"Please Input"},on:{"select":_vm.handleSelect},model:{value:(_vm.newPremiumAct.psVersionTo),callback:function ($$v) {_vm.$set(_vm.newPremiumAct, "psVersionTo", $$v)},expression:"newPremiumAct.psVersionTo"}})],1),_vm._v(" "),_c('el-form-item',{ref:"languages",staticClass:"mktAct__form__languages",attrs:{"label":"Languages"}},[_c('el-select',{attrs:{"name":"languages","filterable":"","multiple":"","placeholder":""},on:{"change":_vm.onChangeLanguages},model:{value:(_vm.newPremiumAct.languages),callback:function ($$v) {_vm.$set(_vm.newPremiumAct, "languages", $$v)},expression:"newPremiumAct.languages"}},_vm._l((_vm.langOptions),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":""}},_vm._l((_vm.newPremiumAct.contents),function(value,index){return _c('div',{staticClass:"mktAct__form__language"},[_c('el-form-item',{attrs:{"label":index.toUpperCase() + ' (' + value.length + '/80)',"prop":'contents[' + index + ']',"rules":[
              { required: true, message: 'Add a content or remove this language', trigger: 'blur' },
              { max: 80, message: 'Length must be less than 80', trigger: 'blur' }
            ]}},[_c('el-input',{attrs:{"type":"textarea"},model:{value:(_vm.newPremiumAct.contents[index]),callback:function ($$v) {_vm.$set(_vm.newPremiumAct.contents, index, $$v)},expression:"newPremiumAct.contents[index]"}})],1)],1)}),0),_vm._v(" "),_c('el-form-item',{ref:"visibility",staticClass:"mktAct__form__visibility",attrs:{"label":"Visibility"}},[_c('el-select',{attrs:{"name":"visibility","filterable":"","multiple":"","placeholder":"Worldwide"},model:{value:(_vm.newPremiumAct.visibility),callback:function ($$v) {_vm.$set(_vm.newPremiumAct, "visibility", $$v)},expression:"newPremiumAct.visibility"}},_vm._l((_vm.visibilityOptions),function(group){return _c('el-option-group',{key:group.label,attrs:{"label":group.label}},_vm._l((group.options),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)}),1)],1),_vm._v(" "),_c('el-form-item',{staticClass:"mktAct__form__visibility__shortcut"},[_c('el-button',{on:{"click":function($event){_vm.newPremiumAct.visibility=_vm.zones.AF.concat(_vm.zones.AS, _vm.zones.EU, _vm.zones.NA, _vm.zones.OC, _vm.zones.SA)}}},[_vm._v("Worldwide")]),_vm._v(" "),_c('el-button',{attrs:{"type":"info"},on:{"click":function($event){_vm.newPremiumAct.visibility=_vm.zones.AF}}},[_vm._v("Africa")]),_vm._v(" "),_c('el-button',{attrs:{"type":"warning"},on:{"click":function($event){_vm.newPremiumAct.visibility=_vm.zones.AS}}},[_vm._v("Asia")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.newPremiumAct.visibility=_vm.zones.EU}}},[_vm._v("Europe")]),_vm._v(" "),_c('el-button',{attrs:{"type":"danger"},on:{"click":function($event){_vm.newPremiumAct.visibility=_vm.zones.NA}}},[_vm._v("N. America")]),_vm._v(" "),_c('el-button',{attrs:{"type":"success"},on:{"click":function($event){_vm.newPremiumAct.visibility=_vm.zones.OC}}},[_vm._v("Oceania")]),_vm._v(" "),_c('el-button',{attrs:{"type":"danger"},on:{"click":function($event){_vm.newPremiumAct.visibility=_vm.zones.SA}}},[_vm._v("S. America")]),_vm._v(" "),_c('el-button',{on:{"click":function($event){_vm.newPremiumAct.visibility=['']}}},[_c('i',{staticClass:"toolbar__icon el-icon-close"})])],1),_vm._v(" "),_c('el-form-item',{staticClass:"mktAct__form__logo",attrs:{"label":"Logo"}},[_c('el-upload',{ref:"logoUpload",staticClass:"upload-demo",attrs:{"action":(_vm.apiUrl + "/premium-activations/logo"),"on-change":_vm.onChangeLogo,"auto-upload":false,"multiple":false,"limit":1,"list-type":"picture"}},[_c('el-button',{attrs:{"size":"small","type":"primary"}},[_vm._v("Click to upload")]),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v("png file with a size less than 500kb")])],1)],1)],1),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary","loading":_vm.saving === true},on:{"click":_vm.addPremiumActivation}},[_vm._v("\n          Confirm\n        ")]),_vm._v(" "),_c('el-button',{on:{"click":function($event){return _vm.resetForm('newPremiumActForm')}}},[_vm._v("Reset")])],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":24}},[_c('el-col',{attrs:{"span":14,"offset":5}},[_c('div',{staticClass:"grid-content"},[_c('div',{staticClass:"mainToolbar pull-right"},[_c('i',{staticClass:"pointer mainToolbar__icon el-icon-plus",on:{"click":function($event){_vm.premiumActDialogVisible = true; _vm.deletion.active = false; _vm.editing = false}}}),_vm._v(" "),_c('i',{staticClass:"pointer mainToolbar__icon el-icon-delete",on:{"click":function($event){_vm.deletion.active = !_vm.deletion.active; _vm.editing = false}}})]),_vm._v(" "),_c('div',{staticClass:"breadcrumb"},[_c('h1',{staticClass:"breadcrumb__h1"},[_vm._v("Marketing Activities")]),_vm._v(" "),_c('h1',{staticClass:"breadcrumb__h2"},[_vm._v("Premium Activation")])])]),_vm._v(" "),_c('div',{staticClass:"grid-content"},[_c('el-input',{staticClass:"searchContent",attrs:{"placeholder":"Search","prefix-icon":"el-icon-search"},nativeOn:{"keyup":function($event){return _vm.seachActivity.apply(null, arguments)}}})],1),_vm._v(" "),_c('el-collapse',{staticClass:"filtersCollapse"},[_c('el-collapse-item',{attrs:{"title":"Filters","name":"1"}},[_c('div',{staticClass:"grid-content filtersCollapse__tabpanel"},[_c('el-form',{ref:"form",attrs:{"model":_vm.filter,"label-width":"120px"}},[_c('el-form-item',{attrs:{"label":"Languages"}},[_c('el-select',{attrs:{"name":"languages","filterable":"","multiple":"","placeholder":"All languages"},on:{"change":_vm.onChangeLanguages},model:{value:(_vm.filter.languages),callback:function ($$v) {_vm.$set(_vm.filter, "languages", $$v)},expression:"filter.languages"}},_vm._l((_vm.langOptions),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Countries"}},[_c('el-select',{attrs:{"name":"visibility","filterable":"","multiple":"","placeholder":"Worldwide"},model:{value:(_vm.filter.countries),callback:function ($$v) {_vm.$set(_vm.filter, "countries", $$v)},expression:"filter.countries"}},_vm._l((_vm.visibilityOptions),function(group){return _c('el-option-group',{key:group.label,attrs:{"label":group.label}},_vm._l((group.options),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)}),1)],1),_vm._v(" "),_c('el-form-item',{staticClass:"mktAct__form__visibility__shortcut"},[_c('el-button',{on:{"click":function($event){_vm.filter.countries=_vm.zones.AF.concat(_vm.zones.AS, _vm.zones.EU, _vm.zones.NA, _vm.zones.OC, _vm.zones.SA)}}},[_vm._v("Worldwide")]),_vm._v(" "),_c('el-button',{attrs:{"type":"info"},on:{"click":function($event){_vm.filter.countries=_vm.zones.AF}}},[_vm._v("Africa")]),_vm._v(" "),_c('el-button',{attrs:{"type":"warning"},on:{"click":function($event){_vm.filter.countries=_vm.zones.AS}}},[_vm._v("Asia")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.filter.countries=_vm.zones.EU}}},[_vm._v("Europe")]),_vm._v(" "),_c('el-button',{attrs:{"type":"danger"},on:{"click":function($event){_vm.filter.countries=_vm.zones.NA}}},[_vm._v("N. America")]),_vm._v(" "),_c('el-button',{attrs:{"type":"success"},on:{"click":function($event){_vm.filter.countries=_vm.zones.OC}}},[_vm._v("Oceania")]),_vm._v(" "),_c('el-button',{attrs:{"type":"danger"},on:{"click":function($event){_vm.filter.countries=_vm.zones.SA}}},[_vm._v("S. America")]),_vm._v(" "),_c('el-button',{on:{"click":function($event){_vm.filter.countries=['']}}},[_c('i',{staticClass:"toolbar__icon el-icon-close"})])],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Status"}},[_c('el-checkbox-group',{model:{value:(_vm.filter.status),callback:function ($$v) {_vm.$set(_vm.filter, "status", $$v)},expression:"filter.status"}},[_c('el-checkbox',{attrs:{"label":"Off","border":""}}),_vm._v(" "),_c('el-checkbox',{attrs:{"label":"Stand by","border":""}}),_vm._v(" "),_c('el-checkbox',{attrs:{"label":"On","border":""}})],1)],1),_vm._v(" "),_c('el-form-item',{staticClass:"filtersCollapse__tabpanel__applyBlock"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.onApplyFilters}},[_vm._v("Apply")]),_vm._v(" "),_c('el-button',{on:{"click":_vm.onClearFilters}},[_vm._v("Clear")])],1)],1)],1)])],1),_vm._v(" "),(_vm.deletion.active)?_c('div',{staticClass:"grid-content pageContent"},[_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.deletion.activities.length),expression:"deletion.activities.length"}],attrs:{"loading":_vm.deletion.activities.loading === true,"type":"danger","plain":""},on:{"click":_vm.deleteActivities}},[_vm._v("\n            Delete\n          ")]),_vm._v(" "),_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.deletion.activities.length),expression:"!deletion.activities.length"}],attrs:{"type":"danger","plain":"","disabled":""}},[_vm._v("Delete")]),_vm._v(" "),_c('el-button',{attrs:{"plain":""},on:{"click":function($event){_vm.deletion.active = false}}},[_vm._v("Cancel")])],1):_vm._e(),_vm._v(" "),_c('el-row',{staticClass:"pageContent",attrs:{"gutter":24}},[_c('el-col',{attrs:{"span":24}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.premiumActs.length),expression:"!premiumActs.length"}],staticClass:"spinner"},[_c('div',{staticClass:"double-bounce1"}),_vm._v(" "),_c('div',{staticClass:"double-bounce2"})]),_vm._v(" "),_vm._l((_vm.premiumActs),function(premiumAct,index){return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.search.hiddenActivities.indexOf(index) === -1 && _vm.filter.hiddenActivities.indexOf(index) === -1),expression:"search.hiddenActivities.indexOf(index) === -1 && filter.hiddenActivities.indexOf(index) === -1"}],staticClass:"mktAct",class:{
                  'mktAct--active': premiumAct.status==='On',
                  'mktAct--pending': premiumAct.status==='Stand by',
                  'mktAct--editing': _vm.editing===index
                }},[_c('div',{staticClass:"mktAct__header",on:{"click":function($event){_vm.editing = _vm.editing === false ? index : false}}},[_c('div',{staticClass:"mktAct__header__logo",style:({ backgroundImage: ("url('" + (premiumAct.logoUrl) + "')") })}),_vm._v(" "),_c('h1',{staticClass:"mktAct__header__partnerName"},[_vm._v(_vm._s(premiumAct.name))]),_vm._v(" "),(_vm.deletion.active)?_c('el-checkbox',{staticClass:"mktAct__header__deleteCheckbox",on:{"change":function($event){return _vm.onChangeDeleteCheckbox(index, $event)}}}):_vm._e()],1),_vm._v(" "),_c('el-collapse-transition',[(_vm.editing===index)?_c('div',{staticClass:"mktAct__edit"},[_c('el-form',{ref:"form",refInFor:true,staticClass:"mktAct__form",attrs:{"model":premiumAct,"label-width":"120px"}},[_c('el-form-item',{attrs:{"label":"Status"}},[_c('el-radio-group',{model:{value:(premiumAct.status),callback:function ($$v) {_vm.$set(premiumAct, "status", $$v)},expression:"premiumAct.status"}},[_c('el-radio-button',{attrs:{"label":"Off"}}),_vm._v(" "),_c('el-radio-button',{attrs:{"label":"Stand by"}}),_vm._v(" "),_c('el-radio-button',{attrs:{"label":"On"}})],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Banner name"}},[_c('el-input',{model:{value:(premiumAct.name),callback:function ($$v) {_vm.$set(premiumAct, "name", $$v)},expression:"premiumAct.name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Tech name"}},[_c('el-input',{model:{value:(premiumAct.techName),callback:function ($$v) {_vm.$set(premiumAct, "techName", $$v)},expression:"premiumAct.techName"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"PS versions"}},[_c('el-autocomplete',{staticClass:"inline-input",attrs:{"fetch-suggestions":_vm.querySearch,"placeholder":"Please Input"},on:{"select":_vm.handleSelect},model:{value:(premiumAct.psVersionFrom),callback:function ($$v) {_vm.$set(premiumAct, "psVersionFrom", $$v)},expression:"premiumAct.psVersionFrom"}}),_vm._v("\n                        to\n                        "),_c('el-autocomplete',{staticClass:"inline-input",attrs:{"fetch-suggestions":_vm.querySearch,"placeholder":"Please Input"},on:{"select":_vm.handleSelect},model:{value:(premiumAct.psVersionTo),callback:function ($$v) {_vm.$set(premiumAct, "psVersionTo", $$v)},expression:"premiumAct.psVersionTo"}})],1),_vm._v(" "),_c('el-form-item',{ref:"languages",refInFor:true,staticClass:"mktAct__form__languages",attrs:{"label":"Languages"}},[_c('el-select',{attrs:{"name":"languages","filterable":"","multiple":"","placeholder":""},on:{"change":_vm.onChangeLanguages},model:{value:(premiumAct.languages),callback:function ($$v) {_vm.$set(premiumAct, "languages", $$v)},expression:"premiumAct.languages"}},_vm._l((_vm.langOptions),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":""}},_vm._l((premiumAct.contents),function(value,index){return _c('div',{staticClass:"mktAct__form__language"},[_c('el-form-item',{attrs:{"label":index.toUpperCase() + ' (' + value.length + '/80)',"prop":'contents[' + index + ']',"rules":[
                            { required: true, message: 'Add a content or remove this language', trigger: 'blur' },
                            { max: 80, message: 'Length must be less than 80', trigger: 'blur' }
                          ]}},[_c('el-input',{attrs:{"type":"textarea"},model:{value:(premiumAct.contents[index]),callback:function ($$v) {_vm.$set(premiumAct.contents, index, $$v)},expression:"premiumAct.contents[index]"}})],1)],1)}),0),_vm._v(" "),_c('el-form-item',{ref:"visibility",refInFor:true,staticClass:"mktAct__form__visibility",attrs:{"label":"Visibility"}},[_c('el-select',{attrs:{"name":"visibility","filterable":"","multiple":"","placeholder":"Worldwide"},model:{value:(premiumAct.visibility),callback:function ($$v) {_vm.$set(premiumAct, "visibility", $$v)},expression:"premiumAct.visibility"}},_vm._l((_vm.visibilityOptions),function(group){return _c('el-option-group',{key:group.label,attrs:{"label":group.label}},_vm._l((group.options),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)}),1)],1),_vm._v(" "),_c('el-form-item',{staticClass:"mktAct__form__visibility__shortcut"},[_c('el-button',{on:{"click":function($event){premiumAct.visibility=_vm.zones.AF.concat(_vm.zones.AS, _vm.zones.EU, _vm.zones.NA, _vm.zones.OC, _vm.zones.SA)}}},[_vm._v("Worldwide")]),_vm._v(" "),_c('el-button',{attrs:{"type":"info"},on:{"click":function($event){premiumAct.visibility=_vm.zones.AF}}},[_vm._v("Africa")]),_vm._v(" "),_c('el-button',{attrs:{"type":"warning"},on:{"click":function($event){premiumAct.visibility=_vm.zones.AS}}},[_vm._v("Asia")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){premiumAct.visibility=_vm.zones.EU}}},[_vm._v("Europe")]),_vm._v(" "),_c('el-button',{attrs:{"type":"danger"},on:{"click":function($event){premiumAct.visibility=_vm.zones.NA}}},[_vm._v("N. America")]),_vm._v(" "),_c('el-button',{attrs:{"type":"success"},on:{"click":function($event){premiumAct.visibility=_vm.zones.OC}}},[_vm._v("Oceania")]),_vm._v(" "),_c('el-button',{attrs:{"type":"danger"},on:{"click":function($event){premiumAct.visibility=_vm.zones.SA}}},[_vm._v("S. America")]),_vm._v(" "),_c('el-button',{on:{"click":function($event){premiumAct.visibility=['']}}},[_c('i',{staticClass:"toolbar__icon el-icon-close"})])],1),_vm._v(" "),_c('el-form-item',{staticClass:"mktAct__form__logo",attrs:{"label":"Logo"}},[_c('el-upload',{ref:("logoUpload" + index),refInFor:true,staticClass:"upload-demo",attrs:{"action":(_vm.apiUrl + "/premium-activations/logo"),"on-change":_vm.onChangeLogo,"auto-upload":false,"multiple":false,"limit":1,"list-type":"picture"}},[_c('el-button',{attrs:{"size":"small","type":"primary"}},[_vm._v("Click to upload")]),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v("png file with a size less than 500kb")])],1)],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","loading":_vm.saving === _vm.editing},on:{"click":_vm.updatePremiumActivation}},[_vm._v("Save")]),_vm._v(" "),_c('el-button',{on:{"click":function($event){_vm.editing=false}}},[_vm._v("Cancel")])],1)],1)],1):_vm._e()])],1)])})],2)],1)],1)],1)],1)])}
var Premium_staticRenderFns = []
var Premium_esExports = { render: Premium_render, staticRenderFns: Premium_staticRenderFns }
/* harmony default export */ var components_Premium = (Premium_esExports);
// CONCATENATED MODULE: ./src/components/Premium.vue
function Premium_injectStyle (ssrContext) {
  __webpack_require__("uAis")
  __webpack_require__("tSYf")
}
var Premium_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Premium___vue_template_functional__ = false
/* styles */
var Premium___vue_styles__ = Premium_injectStyle
/* scopeId */
var Premium___vue_scopeId__ = "data-v-143ffc40"
/* moduleIdentifier (server only) */
var Premium___vue_module_identifier__ = null
var Premium_Component = Premium_normalizeComponent(
  Premium,
  components_Premium,
  Premium___vue_template_functional__,
  Premium___vue_styles__,
  Premium___vue_scopeId__,
  Premium___vue_module_identifier__
)

/* harmony default export */ var src_components_Premium = (Premium_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Tips.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var Tips = ({
  name: 'Tips',
  data: function data() {
    return {
      env: Object({"NODE_ENV":"production","DEBUG_MODE":false}), // Environement variables
      deletion: {
        activities: [],
        loading: false,
        active: false
      },
      search: {
        hiddenActivities: [],
        query: ''
      },
      langOptions: languages_languages,
      zones: zones,
      visibilityOptions: countriesListByRegion,
      tips: [],
      editing: false,
      saving: false,
      tipDialogVisible: false,
      newTip: {
        status: 'Off',
        name: '',
        techName: '',
        languages: ['EN'],
        contents: {
          EN: [{
            title: '',
            content: '',
            cta: 'More information?',
            addonUrl: ''
          }]
        },
        visibility: []
      },
      tipRules: {
        name: [{ required: true, message: 'Please input Activity name', trigger: 'blur' }],
        techName: [{ required: true, message: 'Please input Activity partner name', trigger: 'blur' }],
        content: [{
          required: true, message: 'Please input a content or remove this language', trigger: 'blur'
        }, {
          max: 80, message: 'length should be less than 80', trigger: 'blur'
        }]
      },
      filter: {
        languages: [],
        countries: [],
        hiddenActivities: [],
        status: ['Off', 'Stand by', 'On']
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    // Get the Tips list
    axios_default()({
      method: 'GET',
      url: this.apiUrl + '/tips',
      headers: {
        Authorization: this.$idToken
      }
    }).then(function (result) {
      console.log('result:', result);
      _this.tips = result.data;
    }, function (error) {
      console.error(error);
    });
  },

  methods: {
    /**
     * When the user type a seach, filter the activities by matching name or
     * tech id
     * @param {Event} e
     */
    seachActivity: function seachActivity(e) {
      var query = e.target.value.toLowerCase();
      var matchs = [];
      for (var i = 0; i < this.tips.length; i++) {
        var name = this.tips[i].name.toLowerCase();
        var techName = this.tips[i].techName.toLowerCase();
        if (name.indexOf(query) === -1 && techName.indexOf(query) === -1) {
          matchs.push(i);
        }
      }

      this.search.hiddenActivities = matchs;
    },

    /**
     * Reset the form
     */
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
      this.newTip = {
        isLive: false,
        name: '',
        techName: '',
        languages: ['EN'],
        contents: {
          EN: [{
            title: '',
            content: '',
            cta: 'More information?',
            addonUrl: ''
          }]
        },
        visibility: []
      };
      // Clear the uploaded file list
      this.$refs.logoUpload.clearFiles();
    },

    /**
     * addTip
     */
    addTip: function addTip() {
      var _this2 = this;

      console.log('In addTip');
      // Set the loading state on the submit btn
      this.saving = true;

      var data = new FormData();
      data.append('activity', stringify_default()(this.newTip));

      // If there is a logo to upload
      if (this.$refs.logoUpload.uploadFiles[0]) {
        // Get the file for the logo
        data.append('file', this.$refs.logoUpload.uploadFiles[0].raw);
      }

      // Insert an activity
      axios_default()({
        method: 'POST',
        url: this.apiUrl + '/tips',
        data: data,
        headers: {
          Authorization: this.$idToken,
          'content-type': 'multipart/form-data'
        }
      }).then(function (result) {
        // Unset the loading state on the submit btn
        _this2.saving = false;

        // Clear the uploaded file list
        _this2.resetForm('newTipForm');
        // Close the modal
        _this2.tipDialogVisible = false;

        // Notify the user that the creation was successfull
        _this2.$notify.success({
          title: 'Successfull insert',
          message: 'The new tips has been added'
        });

        // Update the tip list
        axios_default()({
          method: 'GET',
          url: _this2.apiUrl + '/tips',
          headers: {
            Authorization: _this2.$idToken
          }
        }).then(function (tips) {
          _this2.tips = tips.data;
        }, function (error) {
          console.error(error);
        });
      }).catch(function (error) {
        // Unset the loading state on the submit btn
        _this2.saving = false;

        var activity = JSON.parse(data.get('activity'));
        switch (error.response.status) {
          case 401:
            // 401 Unauthorized
            _this2.$notify.error({
              title: 'Error',
              message: 'You are not authorized to add a new activity'
            });
            break;
          case 403:
            // 403 Forbidden
            _this2.$notify.error({
              title: 'Error',
              message: 'Non-existent bucket or you don\'t have the permission to\n              use it. Please contact your administrator'
            });
            break;
          case 409:
            // 409 Conflict
            _this2.$notify.error({
              title: 'Error',
              message: 'An activity with the partner name "' + activity.techName + '"\n              already exist'
            });
            break;
          case 400:
            // Missing or wrong parameter
            if (error.message) {
              _this2.$notify.error({
                title: 'Error',
                message: 'Missing of wrong information submited'
              });
            }
            break;
          default:
            _this2.$notify.error({
              title: 'Error',
              message: 'Unknow error. Please contact your administrator'
            });
            break;
        }
      });
    },

    /**
     * On click on a checkbox for the deletion of an activity, add / remove
     * this activity from this.deletion.activities
     * @param {Number} index - The index of the selected activity from this.tips
     * @param {Boolean} state - Whether or not the checkbox is checked
     */
    onChangeDeleteCheckbox: function onChangeDeleteCheckbox(index, state) {
      if (state === true) {
        this.deletion.activities.push(index);
      } else {
        var pos = this.deletion.activities.indexOf(index);
        this.deletion.activities.splice(pos, 1);
      }
    },

    /**
     * Delete all the activities in the `this.deletion.activities` array
     */
    deleteActivities: function deleteActivities() {
      var _this3 = this;

      console.log('On deleteActivities');
      // Set the loading state to the submit button
      this.deletion.loading = true;

      // Get the Google Storage keys of the activities to remove
      var activityKeys = [];
      for (var i = 0; i < this.deletion.activities.length; i++) {
        activityKeys.push(this.tips[this.deletion.activities[i]].key);
      }

      var data = {
        keys: activityKeys
      };

      axios_default()({
        method: 'DELETE',
        url: this.apiUrl + '/tips',
        data: data,
        headers: {
          Authorization: this.$idToken,
          'content-type': 'application/json'
        }
      }).then(function (result) {
        // Notify the user that the update was successfull
        _this3.$notify.success({
          title: 'Deletion successfull',
          message: 'The selected tips has been deleted'
        });

        // Hide the deletion UI
        _this3.deletion = {
          activities: [],
          loading: false,
          active: false
        };

        // Update the tip list
        axios_default()({
          method: 'GET',
          url: _this3.apiUrl + '/tips',
          headers: {
            Authorization: _this3.$idToken
          }
        }).then(function (tips) {
          _this3.tips = tips.data;
        }, function (error) {
          console.error(error);
        });
      }).catch(function (error) {
        console.error(error);
        // Notify the user that an error occurred
        _this3.$notify.error({
          title: 'Error',
          message: 'An error has occurred, please contact the administrator'
        });

        _this3.deletion = {
          activities: [],
          loading: false,
          active: false
        };
      });
    },

    /**
     * Triggers when the selected languages changes
     * @param {String} languages - current selected value
     */
    onChangeLanguages: function onChangeLanguages(languages) {
      // If we are editing an existing marketing activity
      if (this.editing !== false) {
        // Look for added language
        for (var i = 0; i < languages.length; i++) {
          if (!this.tips[this.editing].contents[languages[i]]) {
            this.$set(this.tips[this.editing].contents, languages[i], [{
              title: '',
              content: '',
              cta: '',
              addonUrl: ''
            }]);
          }
        }
      } else {
        // If editing a new marketing activity
        for (var _i = 0; _i < languages.length; _i++) {
          if (!this.newTip.contents[languages[_i]]) {
            this.$set(this.newTip.contents, languages[_i], [{
              title: '',
              content: '',
              cta: '',
              addonUrl: ''
            }]);
          }
        }
      }
    },

    /**
     * Add a new tips form for the given language of the currently editing tips
     * @param {String} language
     * @param {Event} e
     */
    addLangContent: function addLangContent(language, e) {
      e.stopPropagation();

      // If we are editing an existing marketing activity
      if (this.editing !== false) {
        this.tips[this.editing].contents[language].unshift({
          title: '',
          content: '',
          cta: '',
          addonUrl: ''
        });
      } else {
        // If editing a new marketing activity
        this.newTip.contents[language].unshift({
          title: '',
          content: '',
          cta: '',
          addonUrl: ''
        });
      }
    },

    /**
     * Remove the given content of the given language of the currently editing
     * tips
     * @param {String} language
     * @param {Number} index
     */
    deleteLangContent: function deleteLangContent(language, index) {
      // If we are editing an existing marketing activity
      if (this.editing !== false) {
        this.tips[this.editing].contents[language].splice(index, 1);
      } else {
        // If editing a new marketing activity
        this.newTip.contents[language].splice(index, 1);
      }
    },

    /**
     * Remove all the content of the given language of the currently editing
     * tips
     * @param {String} language
     * @param {Event} e
     */
    deleteTipLang: function deleteTipLang(language, e) {
      e.stopPropagation();

      delete this.tips[this.editing].contents[language];

      var index = this.tips[this.editing].languages.indexOf(language);
      this.tips[this.editing].languages.splice(index, 1);
    },

    /**
     * Handle the changes on the file input for the premium activation logo
     * @param {Object} file - The submited file
     * @param {Array} fileList - The list of files for this upload component
     */
    onChangeLogo: function onChangeLogo(file, fileList) {
      var _this4 = this;

      var typeError = { title: 'Error', message: 'Only png files are allowed' };
      var dimError = { title: 'Error', message: 'The logo dimension must be 100x28 pixels' };
      var sizeError = { title: 'Error', message: 'The file size can\'t exceed 1 Mo' };

      // Check the type of the file
      if (file.raw.type !== 'image/png') {
        // Notify the user that an error occurred
        this.$notify.error(typeError);
        // Remove the file preview
        if (this.editing !== false) {
          this.$refs['logoUpload' + this.editing][0].clearFiles();
        } else {
          this.$refs.logoUpload.clearFiles();
        }
      }

      // Check dimensions of the uploaded image
      var reader = new FileReader();
      reader.onload = function (e) {
        var image = new Image();
        image.src = e.target.result;

        image.onload = function () {
          if (image.height !== 28 || image.width !== 100) {
            // Notify the user that an error occurred
            _this4.$notify.error(dimError);
            // Remove the file preview
            if (_this4.editing !== false) {
              // If editing an existing marketing activity
              _this4.$refs['logoUpload' + _this4.editing][0].clearFiles();
            } else {
              // If editing a new marketing activity
              _this4.$refs.logoUpload.clearFiles();
            }
          }
        };
      };
      reader.readAsDataURL(file.raw);
    },

    /**
     * Update the tip
     */
    updateTip: function updateTip() {
      var _this5 = this;

      console.log('In updateTip');
      // Set the loading state on the submit btn
      this.saving = this.editing;

      if (this.editing !== false && this.tips[this.editing]) {
        // Format the data to be send
        var data = new FormData();
        data.append('activity', stringify_default()(this.tips[this.editing]));
        console.log('data:', data);

        // If there is a logo to upload
        if (this.$refs['logoUpload' + this.editing][0].uploadFiles[0]) {
          // Get the file for the logo
          data.append('file', this.$refs['logoUpload' + this.editing][0].uploadFiles[0].raw);
        }

        // Update an activity
        axios_default()({
          method: 'PUT',
          url: this.apiUrl + '/tips',
          data: data,
          headers: {
            Authorization: this.$idToken,
            'content-type': 'multipart/form-data'
          }
        }).then(function (result) {
          var tip = result.data;
          // Update the tip with the new data
          tip.logoUrl = tip.logoUrl + '?' + +new Date();
          _this5.tips[_this5.editing] = tip;
          _this5.tips[_this5.editing].key = ['Tips', tip.name];

          // Notify the user that the update was successfull
          _this5.$notify.success({
            title: 'Update successfull',
            message: tip.name + ' has been updated'
          });

          // Remove the file preview
          _this5.$refs['logoUpload' + _this5.editing][0].clearFiles();

          // Unset the loading state on the submit btn
          _this5.saving = false;

          // Close the tip edition panel
          _this5.editing = false;
        }, function (error) {
          console.error(error);
          // Unset the loading state on the submit btn
          _this5.saving = false;

          _this5.$notify.error({
            title: 'Error',
            message: 'An error has occurred, please contact the administrator'
          });
        });
      }
    },

    /**
     * Determine if an array contains one or more items from another array.
     * @param {array} haystack the array to search.
     * @param {array} arr the array providing items to check for in the haystack.
     * @return {boolean} true|false if haystack contains at least one item from arr.
     */
    findOne: function findOne(haystack, arr) {
      return arr.some(function (v) {
        // eslint-disable-line
        return haystack.indexOf(v) >= 0;
      });
    },

    /**
     * Apply the user filters
     */
    onApplyFilters: function onApplyFilters() {
      var matchs = [];
      for (var i = 0; i < this.tips.length; i++) {
        var languages = this.tips[i].languages;
        var visibility = this.tips[i].visibility;
        var status = this.tips[i].status;

        // If there is a language filter
        if (this.filter.languages.length && !this.findOne(languages, this.filter.languages)) {
          matchs.push(i);
        }

        // If there is a country filter
        if (this.filter.countries.length && this.filter.countries[0] !== '' && !this.findOne(visibility, this.filter.countries)) {
          matchs.push(i);
        }

        // If the status is not in the status filter
        if (!this.filter.status.includes(status)) {
          matchs.push(i);
        }
      }

      this.filter.hiddenActivities = matchs;
    },

    /**
     * Clear the filter form
     */
    onClearFilters: function onClearFilters() {
      this.filter = {
        languages: [],
        countries: [],
        hiddenActivities: [],
        status: ['Off', 'Stand by', 'On']
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-356cf5a6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tips.vue
var Tips_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-dialog',{attrs:{"title":"Add a new Tip","visible":_vm.tipDialogVisible,"width":"50%"},on:{"update:visible":function($event){_vm.tipDialogVisible=$event}}},[_c('el-form',{ref:"newTipForm",staticClass:"mktAct__form",attrs:{"model":_vm.newTip,"rules":_vm.tipRules,"label-width":"120px"}},[_c('el-form-item',{attrs:{"label":"Status"}},[_c('el-radio-group',{model:{value:(_vm.newTip.status),callback:function ($$v) {_vm.$set(_vm.newTip, "status", $$v)},expression:"newTip.status"}},[_c('el-radio-button',{attrs:{"label":"Off"}}),_vm._v(" "),_c('el-radio-button',{attrs:{"label":"Stand by"}}),_vm._v(" "),_c('el-radio-button',{attrs:{"label":"On"}})],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Banner name","prop":"name"}},[_c('el-input',{model:{value:(_vm.newTip.name),callback:function ($$v) {_vm.$set(_vm.newTip, "name", $$v)},expression:"newTip.name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Partner Name","prop":"techName"}},[_c('el-input',{model:{value:(_vm.newTip.techName),callback:function ($$v) {_vm.$set(_vm.newTip, "techName", $$v)},expression:"newTip.techName"}})],1),_vm._v(" "),_c('el-form-item',{ref:"languages",staticClass:"mktAct__form__languages",attrs:{"label":"Languages"}},[_c('el-select',{attrs:{"name":"languages","filterable":"","multiple":"","placeholder":""},on:{"change":_vm.onChangeLanguages},model:{value:(_vm.newTip.languages),callback:function ($$v) {_vm.$set(_vm.newTip, "languages", $$v)},expression:"newTip.languages"}},_vm._l((_vm.langOptions),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":""}},_vm._l((_vm.newTip.languages),function(lang,index){return _c('div',{staticClass:"mktAct__form__language"},[_c('el-collapse',[_c('el-collapse-item',{attrs:{"name":index + 1}},[_c('template',{slot:"title"},[_vm._v("\n                "+_vm._s(lang)+" ("+_vm._s(_vm.newTip.contents[lang] ? _vm.newTip.contents[lang].length : 0)+")\n                "),_c('div',{staticClass:"mktAct__form__language__toolbar"},[_c('i',{staticClass:"pointer toolbar__icon el-icon-plus mktAct__form__language__toolbar__btn mktAct__form__language__toolbar__btn--add",on:{"click":function($event){return _vm.addLangContent(lang, $event)}}}),_vm._v(" "),_c('i',{staticClass:"pointer toolbar__icon el-icon-delete mktAct__form__language__toolbar__btn mktAct__form__language__toolbar__btn--delete",on:{"click":function($event){return _vm.deleteTipLang(lang, $event)}}})])]),_vm._v(" "),_vm._l((_vm.newTip.contents[lang]),function(newTipsData,idx){return _c('div',{staticClass:"mktAct__form__language__content"},[_c('i',{staticClass:"pointer toolbar__icon el-icon-delete mktAct__form__language__toolbar__btn mktAct__form__language__toolbar__btn--delete",style:({ position: 'absolute' }),on:{"click":function($event){return _vm.deleteLangContent(lang, idx)}}}),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Title","prop":("contents[" + lang + "][" + idx + "].title"),"rules":[
                  { required: true, message: 'Please input tips title', trigger: 'blur' },
                  { max: 80, message: 'Length must be less than 80', trigger: 'blur' }
                ]}},[_c('el-input',{model:{value:(_vm.newTip.contents[lang][idx].title),callback:function ($$v) {_vm.$set(_vm.newTip.contents[lang][idx], "title", $$v)},expression:"newTip.contents[lang][idx].title"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Content","prop":("contents[" + lang + "][" + idx + "].content"),"rules":[
                  { required: true, message: 'Please input tips content', trigger: 'blur' },
                  { max: 80, message: 'Length must be less than 80', trigger: 'blur' }
                ]}},[_c('el-input',{attrs:{"type":"textarea"},model:{value:(_vm.newTip.contents[lang][idx].content),callback:function ($$v) {_vm.$set(_vm.newTip.contents[lang][idx], "content", $$v)},expression:"newTip.contents[lang][idx].content"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Call to action","prop":("contents[" + lang + "][" + idx + "].cta"),"rules":[
                  { required: true, message: 'Please input tips call to action', trigger: 'blur' },
                  { max: 80, message: 'Length must be less than 80', trigger: 'blur' }
                ]}},[_c('el-input',{model:{value:(_vm.newTip.contents[lang][idx].cta),callback:function ($$v) {_vm.$set(_vm.newTip.contents[lang][idx], "cta", $$v)},expression:"newTip.contents[lang][idx].cta"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Addon url","prop":("contents[" + lang + "][" + idx + "].addonUrl"),"rules":[
                  { required: true, message: 'Please input tips addon url', trigger: 'blur' }
                ]}},[_c('el-input',{model:{value:(_vm.newTip.contents[lang][idx].addonUrl),callback:function ($$v) {_vm.$set(_vm.newTip.contents[lang][idx], "addonUrl", $$v)},expression:"newTip.contents[lang][idx].addonUrl"}})],1)],1)})],2)],1)],1)}),0),_vm._v(" "),_c('el-form-item',{ref:"visibility",staticClass:"mktAct__form__visibility",attrs:{"label":"Visibility"}},[_c('el-select',{attrs:{"name":"visibility","filterable":"","multiple":"","placeholder":"Worldwide"},model:{value:(_vm.newTip.visibility),callback:function ($$v) {_vm.$set(_vm.newTip, "visibility", $$v)},expression:"newTip.visibility"}},_vm._l((_vm.visibilityOptions),function(group){return _c('el-option-group',{key:group.label,attrs:{"label":group.label}},_vm._l((group.options),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)}),1)],1),_vm._v(" "),_c('el-form-item',{staticClass:"mktAct__form__visibility__shortcut"},[_c('el-button',{on:{"click":function($event){_vm.newTip.visibility=_vm.zones.AF.concat(_vm.zones.AS, _vm.zones.EU, _vm.zones.NA, _vm.zones.OC, _vm.zones.SA)}}},[_vm._v("Worldwide")]),_vm._v(" "),_c('el-button',{attrs:{"type":"info"},on:{"click":function($event){_vm.newTip.visibility=_vm.zones.AF}}},[_vm._v("Africa")]),_vm._v(" "),_c('el-button',{attrs:{"type":"warning"},on:{"click":function($event){_vm.newTip.visibility=_vm.zones.AS}}},[_vm._v("Asia")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.newTip.visibility=_vm.zones.EU}}},[_vm._v("Europe")]),_vm._v(" "),_c('el-button',{attrs:{"type":"danger"},on:{"click":function($event){_vm.newTip.visibility=_vm.zones.NA}}},[_vm._v("N. America")]),_vm._v(" "),_c('el-button',{attrs:{"type":"success"},on:{"click":function($event){_vm.newTip.visibility=_vm.zones.OC}}},[_vm._v("Oceania")]),_vm._v(" "),_c('el-button',{attrs:{"type":"danger"},on:{"click":function($event){_vm.newTip.visibility=_vm.zones.SA}}},[_vm._v("S. America")]),_vm._v(" "),_c('el-button',{on:{"click":function($event){_vm.newTip.visibility=['']}}},[_c('i',{staticClass:"toolbar__icon el-icon-close"})])],1),_vm._v(" "),_c('el-form-item',{staticClass:"mktAct__form__logo",attrs:{"label":"Logo"}},[_c('el-upload',{ref:"logoUpload",staticClass:"upload-demo",attrs:{"action":(_vm.apiUrl + "/activities/logo"),"on-change":_vm.onChangeLogo,"auto-upload":false,"multiple":false,"limit":1,"list-type":"picture"}},[_c('el-button',{attrs:{"size":"small","type":"primary"}},[_vm._v("Click to upload")]),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v("png file with a size less than 500kb")])],1)],1)],1),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary","loading":_vm.saving === true},on:{"click":_vm.addTip}},[_vm._v("\n        Confirm\n      ")]),_vm._v(" "),_c('el-button',{on:{"click":function($event){return _vm.resetForm('newTipForm')}}},[_vm._v("Reset")])],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":24}},[_c('el-col',{attrs:{"span":14,"offset":5}},[_c('div',{staticClass:"grid-content"},[_c('div',{staticClass:"mainToolbar pull-right"},[_c('i',{staticClass:"pointer mainToolbar__icon el-icon-plus",on:{"click":function($event){_vm.tipDialogVisible = true; _vm.deletion.active = false; _vm.editing = false}}}),_vm._v(" "),_c('i',{staticClass:"pointer mainToolbar__icon el-icon-delete",on:{"click":function($event){_vm.deletion.active = !_vm.deletion.active; _vm.editing = false}}})]),_vm._v(" "),_c('div',{staticClass:"breadcrumb"},[_c('h1',{staticClass:"breadcrumb__h1"},[_vm._v("Marketing Activities")]),_vm._v(" "),_c('h1',{staticClass:"breadcrumb__h2"},[_vm._v("Tips of the day")])])]),_vm._v(" "),_c('div',{staticClass:"grid-content"},[_c('el-input',{staticClass:"searchContent",attrs:{"placeholder":"Search","prefix-icon":"el-icon-search"},nativeOn:{"keyup":function($event){return _vm.seachActivity.apply(null, arguments)}}})],1),_vm._v(" "),_c('el-collapse',{staticClass:"filtersCollapse"},[_c('el-collapse-item',{attrs:{"title":"Filters","name":"1"}},[_c('div',{staticClass:"grid-content filtersCollapse__tabpanel"},[_c('el-form',{ref:"form",attrs:{"model":_vm.filter,"label-width":"120px"}},[_c('el-form-item',{attrs:{"label":"Languages"}},[_c('el-select',{attrs:{"name":"languages","filterable":"","multiple":"","placeholder":"All languages"},on:{"change":_vm.onChangeLanguages},model:{value:(_vm.filter.languages),callback:function ($$v) {_vm.$set(_vm.filter, "languages", $$v)},expression:"filter.languages"}},_vm._l((_vm.langOptions),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Countries"}},[_c('el-select',{attrs:{"name":"visibility","filterable":"","multiple":"","placeholder":"Worldwide"},model:{value:(_vm.filter.countries),callback:function ($$v) {_vm.$set(_vm.filter, "countries", $$v)},expression:"filter.countries"}},_vm._l((_vm.visibilityOptions),function(group){return _c('el-option-group',{key:group.label,attrs:{"label":group.label}},_vm._l((group.options),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)}),1)],1),_vm._v(" "),_c('el-form-item',{staticClass:"mktAct__form__visibility__shortcut"},[_c('el-button',{on:{"click":function($event){_vm.filter.countries=_vm.zones.AF.concat(_vm.zones.AS, _vm.zones.EU, _vm.zones.NA, _vm.zones.OC, _vm.zones.SA)}}},[_vm._v("Worldwide")]),_vm._v(" "),_c('el-button',{attrs:{"type":"info"},on:{"click":function($event){_vm.filter.countries=_vm.zones.AF}}},[_vm._v("Africa")]),_vm._v(" "),_c('el-button',{attrs:{"type":"warning"},on:{"click":function($event){_vm.filter.countries=_vm.zones.AS}}},[_vm._v("Asia")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.filter.countries=_vm.zones.EU}}},[_vm._v("Europe")]),_vm._v(" "),_c('el-button',{attrs:{"type":"danger"},on:{"click":function($event){_vm.filter.countries=_vm.zones.NA}}},[_vm._v("N. America")]),_vm._v(" "),_c('el-button',{attrs:{"type":"success"},on:{"click":function($event){_vm.filter.countries=_vm.zones.OC}}},[_vm._v("Oceania")]),_vm._v(" "),_c('el-button',{attrs:{"type":"danger"},on:{"click":function($event){_vm.filter.countries=_vm.zones.SA}}},[_vm._v("S. America")]),_vm._v(" "),_c('el-button',{on:{"click":function($event){_vm.filter.countries=['']}}},[_c('i',{staticClass:"toolbar__icon el-icon-close"})])],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Status"}},[_c('el-checkbox-group',{model:{value:(_vm.filter.status),callback:function ($$v) {_vm.$set(_vm.filter, "status", $$v)},expression:"filter.status"}},[_c('el-checkbox',{attrs:{"label":"Off","border":""}}),_vm._v(" "),_c('el-checkbox',{attrs:{"label":"Stand by","border":""}}),_vm._v(" "),_c('el-checkbox',{attrs:{"label":"On","border":""}})],1)],1),_vm._v(" "),_c('el-form-item',{staticClass:"filtersCollapse__tabpanel__applyBlock"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.onApplyFilters}},[_vm._v("Apply")]),_vm._v(" "),_c('el-button',{on:{"click":_vm.onClearFilters}},[_vm._v("Clear")])],1)],1)],1)])],1),_vm._v(" "),(_vm.deletion.active)?_c('div',{staticClass:"grid-content pageContent"},[_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.deletion.activities.length),expression:"deletion.activities.length"}],attrs:{"loading":_vm.deletion.activities.loading === true,"type":"danger","plain":""},on:{"click":_vm.deleteActivities}},[_vm._v("\n          Delete\n        ")]),_vm._v(" "),_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.deletion.activities.length),expression:"!deletion.activities.length"}],attrs:{"type":"danger","plain":"","disabled":""}},[_vm._v("Delete")]),_vm._v(" "),_c('el-button',{attrs:{"plain":""},on:{"click":function($event){_vm.deletion.active = false}}},[_vm._v("Cancel")])],1):_vm._e(),_vm._v(" "),_c('el-row',{staticClass:"pageContent",attrs:{"gutter":24}},[_c('el-col',{attrs:{"span":24}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.tips.length),expression:"!tips.length"}],staticClass:"spinner"},[_c('div',{staticClass:"double-bounce1"}),_vm._v(" "),_c('div',{staticClass:"double-bounce2"})]),_vm._v(" "),_vm._l((_vm.tips),function(tip,index){return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.search.hiddenActivities.indexOf(index) === -1 && _vm.filter.hiddenActivities.indexOf(index) === -1),expression:"search.hiddenActivities.indexOf(index) === -1 && filter.hiddenActivities.indexOf(index) === -1"}],staticClass:"mktAct",class:{
                'mktAct--active': tip.status==='On',
                'mktAct--pending': tip.status==='Stand by',
                'mktAct--editing': _vm.editing===index
              }},[_c('div',{staticClass:"mktAct__header",on:{"click":function($event){_vm.editing = _vm.editing === false ? index : false}}},[_c('div',{staticClass:"mktAct__header__logo",style:({ backgroundImage: ("url('" + (tip.logoUrl) + "')") })}),_vm._v(" "),_c('h1',{staticClass:"mktAct__header__partnerName"},[_vm._v(_vm._s(tip.name))]),_vm._v(" "),(_vm.deletion.active)?_c('el-checkbox',{staticClass:"mktAct__header__deleteCheckbox",on:{"change":function($event){return _vm.onChangeDeleteCheckbox(index, $event)}}}):_vm._e()],1),_vm._v(" "),(_vm.editing===index)?_c('div',{staticClass:"mktAct__edit"},[_c('el-form',{ref:"form",refInFor:true,staticClass:"mktAct__form",attrs:{"model":tip,"label-width":"120px"}},[_c('el-form-item',{attrs:{"label":"Status"}},[_c('el-radio-group',{model:{value:(tip.status),callback:function ($$v) {_vm.$set(tip, "status", $$v)},expression:"tip.status"}},[_c('el-radio-button',{attrs:{"label":"Off"}}),_vm._v(" "),_c('el-radio-button',{attrs:{"label":"Stand by"}}),_vm._v(" "),_c('el-radio-button',{attrs:{"label":"On"}})],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Banner name","prop":"name"}},[_c('el-input',{model:{value:(tip.name),callback:function ($$v) {_vm.$set(tip, "name", $$v)},expression:"tip.name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Partner Name"}},[_c('el-input',{model:{value:(tip.techName),callback:function ($$v) {_vm.$set(tip, "techName", $$v)},expression:"tip.techName"}})],1),_vm._v(" "),_c('el-form-item',{ref:"languages",refInFor:true,staticClass:"mktAct__form__languages",attrs:{"label":"Languages"}},[_c('el-select',{attrs:{"name":"languages","filterable":"","multiple":"","placeholder":""},on:{"change":_vm.onChangeLanguages},model:{value:(tip.languages),callback:function ($$v) {_vm.$set(tip, "languages", $$v)},expression:"tip.languages"}},_vm._l((_vm.langOptions),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":""}},_vm._l((tip.languages),function(lang,index){return _c('div',{staticClass:"mktAct__form__language"},[_c('el-collapse',[_c('el-collapse-item',{attrs:{"name":index + 1}},[_c('template',{slot:"title"},[_vm._v("\n                            "+_vm._s(lang)+" ("+_vm._s(tip.contents[lang] ? tip.contents[lang].length : 0)+")\n                            "),_c('div',{staticClass:"mktAct__form__language__toolbar"},[_c('i',{staticClass:"pointer toolbar__icon el-icon-plus mktAct__form__language__toolbar__btn mktAct__form__language__toolbar__btn--add",on:{"click":function($event){return _vm.addLangContent(lang, $event)}}}),_vm._v(" "),_c('i',{staticClass:"pointer toolbar__icon el-icon-delete mktAct__form__language__toolbar__btn mktAct__form__language__toolbar__btn--delete",on:{"click":function($event){return _vm.deleteTipLang(lang, $event)}}})])]),_vm._v(" "),_vm._l((tip.contents[lang]),function(tipsData,idx){return _c('div',{staticClass:"mktAct__form__language__content"},[_c('i',{staticClass:"pointer toolbar__icon el-icon-delete mktAct__form__language__toolbar__btn mktAct__form__language__toolbar__btn--delete",style:({ position: 'absolute' }),on:{"click":function($event){return _vm.deleteLangContent(lang, idx)}}}),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Title","prop":("contents[" + lang + "][" + idx + "].title"),"rules":[
                              { required: true, message: 'Please input tips title', trigger: 'blur' },
                              { max: 80, message: 'Length must be less than 80', trigger: 'blur' }
                            ]}},[_c('el-input',{model:{value:(tip.contents[lang][idx].title),callback:function ($$v) {_vm.$set(tip.contents[lang][idx], "title", $$v)},expression:"tip.contents[lang][idx].title"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Content","prop":("contents[" + lang + "][" + idx + "].content"),"rules":[
                              { required: true, message: 'Please input tips content', trigger: 'blur' },
                              { max: 80, message: 'Length must be less than 80', trigger: 'blur' }
                            ]}},[_c('el-input',{attrs:{"type":"textarea"},model:{value:(tip.contents[lang][idx].content),callback:function ($$v) {_vm.$set(tip.contents[lang][idx], "content", $$v)},expression:"tip.contents[lang][idx].content"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Call to action","prop":("contents[" + lang + "][" + idx + "].cta"),"rules":[
                              { required: true, message: 'Please input tips call to action', trigger: 'blur' },
                              { max: 80, message: 'Length must be less than 80', trigger: 'blur' }
                            ]}},[_c('el-input',{model:{value:(tip.contents[lang][idx].cta),callback:function ($$v) {_vm.$set(tip.contents[lang][idx], "cta", $$v)},expression:"tip.contents[lang][idx].cta"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Addon url","prop":("contents[" + lang + "][" + idx + "].addonUrl"),"rules":[
                              { required: true, message: 'Please input tips addon url', trigger: 'blur' }
                            ]}},[_c('el-input',{model:{value:(tip.contents[lang][idx].addonUrl),callback:function ($$v) {_vm.$set(tip.contents[lang][idx], "addonUrl", $$v)},expression:"tip.contents[lang][idx].addonUrl"}})],1)],1)})],2)],1)],1)}),0),_vm._v(" "),_c('el-form-item',{ref:"visibility",refInFor:true,staticClass:"mktAct__form__visibility",attrs:{"label":"Visibility"}},[_c('el-select',{attrs:{"name":"visibility","filterable":"","multiple":"","placeholder":"Worldwide"},model:{value:(tip.visibility),callback:function ($$v) {_vm.$set(tip, "visibility", $$v)},expression:"tip.visibility"}},_vm._l((_vm.visibilityOptions),function(group){return _c('el-option-group',{key:group.label,attrs:{"label":group.label}},_vm._l((group.options),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)}),1)],1),_vm._v(" "),_c('el-form-item',{staticClass:"mktAct__form__visibility__shortcut"},[_c('el-button',{on:{"click":function($event){tip.visibility=_vm.zones.AF.concat(_vm.zones.AS, _vm.zones.EU, _vm.zones.NA, _vm.zones.OC, _vm.zones.SA)}}},[_vm._v("Worldwide")]),_vm._v(" "),_c('el-button',{attrs:{"type":"info"},on:{"click":function($event){tip.visibility=_vm.zones.AF}}},[_vm._v("Africa")]),_vm._v(" "),_c('el-button',{attrs:{"type":"warning"},on:{"click":function($event){tip.visibility=_vm.zones.AS}}},[_vm._v("Asia")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){tip.visibility=_vm.zones.EU}}},[_vm._v("Europe")]),_vm._v(" "),_c('el-button',{attrs:{"type":"danger"},on:{"click":function($event){tip.visibility=_vm.zones.NA}}},[_vm._v("N. America")]),_vm._v(" "),_c('el-button',{attrs:{"type":"success"},on:{"click":function($event){tip.visibility=_vm.zones.OC}}},[_vm._v("Oceania")]),_vm._v(" "),_c('el-button',{attrs:{"type":"danger"},on:{"click":function($event){tip.visibility=_vm.zones.SA}}},[_vm._v("S. America")]),_vm._v(" "),_c('el-button',{on:{"click":function($event){tip.visibility=['']}}},[_c('i',{staticClass:"toolbar__icon el-icon-close"})])],1),_vm._v(" "),_c('el-form-item',{staticClass:"mktAct__form__logo",attrs:{"label":"Logo"}},[_c('el-upload',{ref:("logoUpload" + index),refInFor:true,staticClass:"upload-demo",attrs:{"action":(_vm.apiUrl + "/tips/logo"),"on-change":_vm.onChangeLogo,"auto-upload":false,"multiple":false,"limit":1,"list-type":"picture"}},[_c('el-button',{attrs:{"size":"small","type":"primary"}},[_vm._v("Click to upload")]),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v("png file with a size less than 500kb")])],1)],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","loading":_vm.saving === _vm.editing},on:{"click":_vm.updateTip}},[_vm._v("Save")]),_vm._v(" "),_c('el-button',{on:{"click":function($event){_vm.editing=false}}},[_vm._v("Cancel")])],1)],1)],1):_vm._e()])])})],2)],1)],1)],1)],1)}
var Tips_staticRenderFns = []
var Tips_esExports = { render: Tips_render, staticRenderFns: Tips_staticRenderFns }
/* harmony default export */ var components_Tips = (Tips_esExports);
// CONCATENATED MODULE: ./src/components/Tips.vue
function Tips_injectStyle (ssrContext) {
  __webpack_require__("8+oJ")
  __webpack_require__("kT5t")
}
var Tips_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Tips___vue_template_functional__ = false
/* styles */
var Tips___vue_styles__ = Tips_injectStyle
/* scopeId */
var Tips___vue_scopeId__ = "data-v-356cf5a6"
/* moduleIdentifier (server only) */
var Tips___vue_module_identifier__ = null
var Tips_Component = Tips_normalizeComponent(
  Tips,
  components_Tips,
  Tips___vue_template_functional__,
  Tips___vue_styles__,
  Tips___vue_scopeId__,
  Tips___vue_module_identifier__
)

/* harmony default export */ var src_components_Tips = (Tips_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Admin.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var Admin = ({
  name: 'Admin',
  data: function data() {
    return {
      runningTips: false,
      runningPremium: false,
      runningDeploy: false
    };
  },

  methods: {
    migrateTips: function migrateTips() {
      var _this = this;

      this.runningTips = true;

      axios_default()({
        method: 'GET',
        url: this.apiUrl + '/admin/migrate-tips',
        headers: {
          Authorization: this.$idToken
        }
      }).then(function (result) {
        _this.runningTips = false;
        _this.$notify.success({ title: 'Success', message: 'Tips migration done' });
      }, function (error) {
        _this.runningTips = false;
        _this.$notify.error({ title: 'Error', message: 'The tips migration failed' });
      });
    },
    migratePremium: function migratePremium() {
      var _this2 = this;

      this.runningPremium = true;

      axios_default()({
        method: 'GET',
        url: this.apiUrl + '/admin/migrate-premium',
        headers: {
          Authorization: this.$idToken
        }
      }).then(function (result) {
        _this2.runningPremium = false;
        _this2.$notify.success({ title: 'Success', message: 'Premium migration done' });
      }, function (error) {
        _this2.runningPremium = false;
        _this2.$notify.error({ title: 'Error', message: 'The premium migration failed' });
      });
    },
    deploy: function deploy() {
      var _this3 = this;

      this.runningDeploy = true;

      console.log('Will deploy');

      axios_default()({
        method: 'GET',
        url: this.apiUrl + '/admin/deploy-activities',
        headers: {
          Authorization: this.$idToken,
          'content-type': 'application/json'
        }
      }).then(function (result) {
        console.log('result:', result);
        _this3.runningDeploy = false;
        _this3.$notify.success({ title: 'Success', message: 'Activities deployed' });
      }, function (error) {
        _this3.runningDeploy = false;
        _this3.$notify.error({ title: 'Error', message: 'The activities deployement has failed' });
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4407f6e8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin.vue
var Admin_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-row',{attrs:{"gutter":24}},[_c('el-col',{attrs:{"span":14,"offset":5}},[_c('div',{staticClass:"grid-content"},[_c('div',{staticClass:"breadcrumb"},[_c('h1',{staticClass:"breadcrumb__h1"},[_vm._v("Marketing Activities")]),_vm._v(" "),_c('h1',{staticClass:"breadcrumb__h2"},[_vm._v("Deployement")]),_vm._v(" "),_c('p',[_vm._v("\n            By submiting this form you will generate the new configuration\n            files for the marketing activities."),_c('br'),_vm._v("\n            The updated configuration will be immediatly pushed in production.\n          ")])])]),_vm._v(" "),_c('el-row',{staticClass:"pageContent",attrs:{"gutter":24}},[_c('el-col',{attrs:{"span":24}},[_c('el-button',{attrs:{"type":"warning","loading":_vm.runningDeploy,"disabled":_vm.runningDeploy},on:{"click":_vm.deploy}},[_vm._v("\n            Deploy activities\n          ")])],1)],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":24}},[_c('el-col',{attrs:{"span":14,"offset":5}},[_c('div',{staticClass:"grid-content"},[_c('div',{staticClass:"breadcrumb"},[_c('h1',{staticClass:"breadcrumb__h2"},[_vm._v("Fixtures")])])]),_vm._v(" "),_c('el-row',{staticClass:"pageContent",attrs:{"gutter":24}},[_c('el-col',{attrs:{"span":24}},[_c('el-button',{attrs:{"type":"primary","loading":_vm.runningTips},on:{"click":_vm.migrateTips}},[_vm._v("Migrate Tips schema")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","loading":_vm.runningPremium},on:{"click":_vm.migratePremium}},[_vm._v("Migrate Premium schema")])],1)],1)],1)],1)],1)}
var Admin_staticRenderFns = []
var Admin_esExports = { render: Admin_render, staticRenderFns: Admin_staticRenderFns }
/* harmony default export */ var components_Admin = (Admin_esExports);
// CONCATENATED MODULE: ./src/components/Admin.vue
function Admin_injectStyle (ssrContext) {
  __webpack_require__("l0T0")
  __webpack_require__("StBQ")
}
var Admin_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Admin___vue_template_functional__ = false
/* styles */
var Admin___vue_styles__ = Admin_injectStyle
/* scopeId */
var Admin___vue_scopeId__ = "data-v-4407f6e8"
/* moduleIdentifier (server only) */
var Admin___vue_module_identifier__ = null
var Admin_Component = Admin_normalizeComponent(
  Admin,
  components_Admin,
  Admin___vue_template_functional__,
  Admin___vue_styles__,
  Admin___vue_scopeId__,
  Admin___vue_module_identifier__
)

/* harmony default export */ var src_components_Admin = (Admin_Component.exports);

// CONCATENATED MODULE: ./src/router/index.js







vue_esm["default"].use(vue_router_esm["a" /* default */]);

/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  routes: [{
    path: '/marketing/premium',
    name: 'Premium',
    component: src_components_Premium
  }, {
    path: '/marketing/tips',
    name: 'Tips',
    component: src_components_Tips
  }, {
    path: '/admin',
    name: 'Admin',
    component: src_components_Admin
  }, {
    path: '*',
    name: 'HelloWorld',
    component: src_components_HelloWorld
  }]
}));
// CONCATENATED MODULE: ./src/main.js

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.








vue_esm["default"].config.productionTip = false;
vue_esm["default"].use(element_ui_common_default.a);

var apiUrl = window.location.hostname === 'localhost' ? 'http://127.0.0.1:10010' : 'https://api-' + window.location.hostname;

vue_esm["default"].mixin({
  data: function data() {
    return {
      get apiUrl() {
        return apiUrl;
      }
    };
  }
});

/* eslint-disable no-new */
/* eslint-disable no-undef */
function googleAuth() {
  return axios_default()({ method: 'GET', url: apiUrl + '/public/config' }).then(function (result) {
    var clientId = result.data.clientId;

    return new promise_default.a(function (fulfill) {
      gapi.load('auth2', function () {
        fulfill(clientId);
      });
    });
  }).then(function (clientId) {
    return gapi.auth2.init({
      client_id: clientId,
      hosted_domain: 'prestashop.com'
    });
  }).then(function (GoogleAuth) {
    return new promise_default.a(function (fulfill, reject) {
      // Check if the client is currently signed in
      if (!GoogleAuth.isSignedIn.get()) {
        GoogleAuth.signIn({
          prompt: 'consent',
          scope: 'profile email',
          ux_mode: 'redirect'
        }).then(function () {
          fulfill(GoogleAuth);
        }).catch(function (error) {
          reject(error);
        });
      } else {
        fulfill(GoogleAuth);
      }
    });
  }).then(function (GoogleAuth) {
    vue_esm["default"].prototype.$GoogleAuth = GoogleAuth;
    var GoogleUser = GoogleAuth.currentUser.get();
    console.log('GoogleUser.getAuthResponse():', GoogleUser.getAuthResponse());
    vue_esm["default"].prototype.$idToken = GoogleUser.getAuthResponse().id_token;

    // Instantiate a timer to refresh the token in 1 hour
    setTimeout(googleAuth, 3600000);
  });
}

var vm = new vue_esm["default"]({
  router: router,
  template: '<App/>',
  components: { App: src_App },
  beforeCreate: function beforeCreate() {
    // Get the app configuration from the server
    googleAuth().then(function () {
      // Start the mounting of the Vue instance
      vm.$mount('#app');
    }).catch(function (error) {
      console.error(error);
    });
  }
});

/***/ }),

/***/ "StBQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "c5Db":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gVaA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jvJD":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/puffindev.a987107.png";

/***/ }),

/***/ "kT5t":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "l0T0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tSYf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tvR6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uAis":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.63127963b45d549d49d5.js